import React, { useState, useRef, useEffect, useLayoutEffect, useMemo } from 'react';
import { Info, CloudUpload, X, ChevronDown, Search, Menu, Trash2, ChevronsUpDown, ChevronsDown, XCircle, ChevronRight, CircleCheck, GripVertical } from 'lucide-react';
import { useHistory, useLocation, useParams } from "react-router-dom";
import Tooltip from '../addentities/Tooltip.js';
import { ReactSortable } from 'react-sortablejs';
import { createPortal } from 'react-dom';
import apiHelper from '../../apiHelper';
import { getSpuNamesCache, ensureSpuNamesLoaded, invalidateSpuNamesCache } from '../../spuValidationCache';
import noImage from '../../assets/img/brand/noImage.png'
import MultiSelectSearch from '../../utils/MultiSelectSearch.js';
import CharacterLimitedTextarea from '../../components/CharacterLimitedTextarea';
import DiscardConfirmationModal from '../../components/DiscardConfirmationModal.js';
import UnsavedChangesPrompt from '../../components/UnsavedChangesPrompt.js';
import SpuProgressStepper from '../../components/SpuProgressStepper.js';
import CalendarInput from '../../components/CalendarInput.js';
import SortableHeader from '../../components/SortableHeader.js';
import SimOptionDropdown from '../../components/SimOptionDropdown.js';
import AlertNotification from '../../components/AlertNotification.js';
import { ro, tr } from 'date-fns/locale';
import ReactDOM from 'react-dom';
import Pagination from '../../components/Pagination.js';

//const MAX_IMAGES = 5;

// Reference children options

const REFERENCE_OPTIONS = {
  Brands: [
    { label: 'Apple', value: 'apple' },
    { label: 'Samsung', value: 'samsung' },
    { label: 'OnePlus', value: 'oneplus' },
    { label: 'Xiaomi', value: 'xiaomi' },
  ],
  Categories: [
    { label: 'Mobile', value: 'mobile' },
    { label: 'Tablet', value: 'tablet' },
    { label: 'Laptop', value: 'laptop' },
  ],
  SPU: [
    { label: 'iPhone 16', value: 'iphone-16' },
    { label: 'iPhone 16e', value: 'iphone-16e' },
    { label: 'iPhone 16 Pro Max', value: 'iphone-16pm' },
  ],
  SKU: [
    { label: 'iPhone 16 - Black-256GB-Wifi', value: 'sku-b256' },
    { label: 'iPhone 16 - Black-512GB-Wifi', value: 'sku-b512' },
    { label: 'iPhone 16 - Black-1TB-Wifi', value: 'sku-b1tb' },
  ],
};
// First readable message in an API error body: DRF sends {"detail": "..."},
// ["..."] or field errors nested in objects/lists; apiHelper's network
// failure sends {"message": "..."}.
const firstErrorMessage = (body) => {
  if (typeof body === 'string') return body;
  const values = Array.isArray(body) ? body : Object.values(body || {});
  for (const value of values) {
    const message = firstErrorMessage(value);
    if (message) return message;
  }
  return '';
};

{/* SHARED FUNCTION TO DISPLAY LABEL IN TWO LINES IF CONTAINS ' - ' */ }
const renderLabel = (label) => {
  const parts = label.split(' - ');
  if (parts.length === 2) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ color: '#6C757D', fontSize: '12px', marginBottom: '5px' }}>{parts[0]}</span>
        <span style={{ fontSize: '14px' }}>{parts[1]}</span>
      </div>
    );
  }
  return label;
};

const portalRoot = document.getElementById('portal-root');
const OptionPortal = ({ children, style }) =>
  createPortal(
    <div className="options-container main-company-body-inner" style={{ ...style, overflow: 'visible', zIndex: 2000, marginTop: '10px' }}>
      {children}
    </div>,
    portalRoot
  );


export default function EditSpu() {
  const history = useHistory();
  const fileInputRef = useRef(null);

  const [uploadedImages, setUploadedImages] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);

  const [successMessage, setSuccessMessage] = useState('');
  const [validationError, setValidationError] = useState([]);
  const [disabled, setDisabled] = useState(false);

  const { id } = useParams();
  const [skuAttributes, setSkuAttributes] = useState([]);
  const [skuAttributeOptions, setSkuAttributeOptions] = useState([]);
  const [discardModalOpen, setDiscardModalOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [tempParentCategorySearchTerm, setTempParentCategorySearchTerm] = useState("");
  const [tempSearchParentCategory, setTempSearchParentCategory] = useState([]);
  const [parentCategoryDropdownOpen, setParentCategoryDropdownOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const [categorySearch, setCategorySearch] = useState('');
  const categoryRef = useRef(null);
  const [rows3, setRows3] = useState([]);
  const rowRefs3 = useRef({});
  const [showMissingVariationError, setShowMissingVariationError] = useState(false);
  const [configImages, setConfigImages] = useState({});
  const [rowsCf, setRowsCf] = useState({});
  const [configNotes, setConfigNotes] = useState({});
  const [skuCodeRows, setSkuCodeRows] = useState([]);
  const [touched, setTouched] = useState({});
  const [stepData, setStepData] = useState({
    spuData: {},
    skuVariations: {},
    skuConfigurationsData: {},
    skuCodeData: []
  });
  const [isAddConfigDisabled, setIsAddConfigDisabled] = useState(false);
  const [productType, setProductType] = useState([]);

  const [rowErrors, setRowErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const location = useLocation();
  const [allSpus, setAllSpus] = useState(() => getSpuNamesCache() || location.state?.spus || []);
  const [spusLoading, setSpusLoading] = useState(() => getSpuNamesCache() === null);
  const [alert, setAlert] = useState(null);
  const [skuAttr, setSkuAttr] = useState([]);
  const ITEMS_PER_PAGE = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [skuRowErrors, setSkuRowErrors] = useState({});
  const isDiscardingRef = React.useRef(false);
  const originalSkuRowsRef = useRef([]);
const [configImageErrors, setConfigImageErrors] = useState({});
  // // Configuration-specific image handlers
  // const handleConfigImageChange = (e, tabKey) => {
  //   const files = Array.from(e.target.files || []);
  //   const newImgs = makeImageObjects(files);

  //   const imagesWithMetadata = newImgs.map(img => ({
  //     ...img,
  //     spuId: id,
  //     skuIdentifier: tabKey // Using tabKey as SKU identifier
  //   }));

  //   setConfigImages(prev => ({
  //     ...prev,
  //     [tabKey]: [...(prev[tabKey] || []), ...imagesWithMetadata]
  //   }));
  // };

  // const handleConfigDrop = (e, tabKey) => {
  //   e.preventDefault();
  //   setIsDragging(false);
  //   const files = Array.from(e.dataTransfer.files || []);
  //   const newImgs = makeImageObjects(files);

  //   const imagesWithMetadata = newImgs.map(img => ({
  //     ...img,
  //     spuId: id,
  //     skuIdentifier: tabKey
  //   }));

  //   setConfigImages(prev => ({
  //     ...prev,
  //     [tabKey]: [...(prev[tabKey] || []), ...imagesWithMetadata]
  //   }));
  // };

  const handleConfigRemove = (id, tabKey) => {
    setIsDirty(true);
    setConfigImages(prev => ({
      ...prev,
      [tabKey]: (prev[tabKey] || []).filter(x => x.id !== id)
    }));
  };

  const updateRowBulkCf = (id, changes, tabKey) => {
    setRowsCf(prev => ({
      ...prev,
      [tabKey]: (prev[tabKey] ?? []).map(r =>
        r.id === id ? { ...r, ...changes } : r
      )
    }));
  };

  const addRowCf = (tabKey) => {
    setRowsCf(prev => {
      const newId = prev[tabKey]?.length
        ? Math.max(...prev[tabKey].map(r => r.id)) + 1
        : 1;

      const newRow = {
        id: newId,
        fieldName: "",
        fieldType: "Text",
        value: "",
      };

      return {
        ...prev,
        [tabKey]: [...(prev[tabKey] ?? []), newRow]
      };
    });
  };

// Add validation function for configuration images
const validateConfigFiles = (files, tabKey) => {
  const isValid = files.every(
    file =>
      ALLOWED_TYPES.includes(file.type) &&
      file.size <= MAX_FILE_SIZE
  );

  if (!isValid) {
    setConfigImageErrors(prev => ({
      ...prev,
      [tabKey]: 'Upload failed — Only JPEG/PNG files below 1MB are supported'
    }));
    return false;
  }

  // Clear error if validation passes
  setConfigImageErrors(prev => ({
    ...prev,
    [tabKey]: ''
  }));
  return true;
};

// Update handleConfigImageChange to include validation
const handleConfigImageChange = (e, tabKey) => {
  const files = Array.from(e.target.files || []);
  
  if (!files.length) return;
  
  // Validate files first
  const isValid = validateConfigFiles(files, tabKey);
  
  if (!isValid) {
    e.target.value = ''; // reset input
    return;
  }
  
  setIsDirty(true); 
  const newImgs = makeImageObjects(files, (configImages[tabKey] || []).length);
  
  const imagesWithMetadata = newImgs.map(img => ({
    ...img,
    spuId: id,
    skuIdentifier: tabKey
  }));
  
  setConfigImages(prev => ({
    ...prev,
    [tabKey]: [...(prev[tabKey] || []), ...imagesWithMetadata]
  }));
};

// Update handleConfigDrop to include validation
const handleConfigDrop = (e, tabKey) => {
  e.preventDefault();
  setIsDragging(false);
  const files = Array.from(e.dataTransfer.files || []);
  
  if (!files.length) return;
  
  // Validate files first
  const isValid = validateConfigFiles(files, tabKey);
  
  if (!isValid) {
    return;
  }
  
  setIsDirty(true);
  const newImgs = makeImageObjects(files, (configImages[tabKey] || []).length);

  
  const imagesWithMetadata = newImgs.map(img => ({
    ...img,
    spuId: id,
    skuIdentifier: tabKey
  }));
  
  setConfigImages(prev => ({
    ...prev,
    [tabKey]: [...(prev[tabKey] || []), ...imagesWithMetadata]
  }));
};
  const deleteRowCf = (id, tabKey) => {
    setRowsCf(prev => ({
      ...prev,
      [tabKey]: (prev[tabKey] ?? []).filter(r => r.id !== id)
    }));
  };

  const handleCustomFieldBlur = (e, rowId) => {
    const { name, value } = e.target;

    if (!value.trim()) {
      setFormErrors(prev => ({
        ...prev,
        [rowId]: {
          ...prev[rowId],
          [name]: `${labelMap[name]} is required`
        }
      }));
      return;
    }

    setFormErrors(prev => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [name]: ""
      }
    }));

    validateLocalDuplicate(name, value, rowId);

  };

  // const validateOnBlur = (name, value, label) => {
  //   if (!value || !value.trim()) {
  //     setFormErrors(prev => ({
  //       ...prev,
  //       [name]: `${label} is required`
  //     }));
  //     return false;
  //   }

  //   setFormErrors(prev => ({
  //     ...prev,
  //     [name]: ""
  //   }));

  //   validateLocalDuplicate(name, value);
  //   return true;
  // };

  const validateOnBlur = (name, value, label) => {
    const stringValue = String(value || "").trim();

    if (!stringValue) {
      setFormErrors(prev => ({
        ...prev,
        [name]: `${label} is required`
      }));
      return false;
    }

    setFormErrors(prev => ({
      ...prev,
      [name]: ""
    }));
    
    validateLocalDuplicate(name, stringValue);
    return true;
  };


  const validateRowField = (
    rowId,
    field,
    value,
    label,
    tabKey,
    updatedRows // latest rows after state update
  ) => {
    setRowErrors(prev => {
      const errors = { ...prev };

      /* ---------- 1️⃣ REQUIRED VALIDATION ---------- */
      const isEmpty =
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "") ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        errors[rowId] = {
          ...errors[rowId],
          [field]: `${label} is required`,
        };
        return errors;
      }

      /* ---------- 2️⃣ CLEAR PREVIOUS ERROR ---------- */
      if (errors[rowId]?.[field]) {
        delete errors[rowId][field];
        if (Object.keys(errors[rowId]).length === 0) {
          delete errors[rowId];
        }
      }

      /* ---------- 3️⃣ DUPLICATE CHECK (SPU CUSTOM ONLY) ---------- */
      if (field === "fieldName") {
        const normalized = value.trim().toLowerCase();

        const existsInSameSPU = (updatedRows || []).some(
          r =>
            r.id !== rowId && // ignore self
            typeof r.fieldName === "string" &&
            r.fieldName.trim().toLowerCase() === normalized
        );

        if (existsInSameSPU) {
          errors[rowId] = {
            ...errors[rowId],
            fieldName: "Field Name already exists",
          };
        }
      }

      return errors;
    });

    return true;
  };

  const validateRowFieldOnBlur = (
    rowId,
    field,
    value,
    label,
    rows,
    setRowErrors
  ) => {
    setRowErrors(prev => {
      const prevRowErrors = prev[rowId] || {};
      const newRowErrors = { ...prevRowErrors };

      /* ---------- REQUIRED CHECK ---------- */
      if (!value || (typeof value === "string" && !value.trim())) {
        newRowErrors[field] = `${label} is required`;
      } else {
        delete newRowErrors[field];
      }

      /* ---------- DUPLICATE CHECK (ONLY CURRENT ROW) ---------- */
      if (field === "fieldName" && Array.isArray(rows) && value?.trim()) {
        const normalized = value.trim().toLowerCase();

        const isDuplicate = rows.some(
          r =>
            r.id !== rowId &&
            r.fieldName &&
            r.fieldName.trim().toLowerCase() === normalized
        );

        if (isDuplicate) {
          newRowErrors.fieldName = "Field Name already exists";
        } else {
          delete newRowErrors.fieldName;
        }
      }

      return {
        ...prev,
        [rowId]: newRowErrors, // ✅ ONLY update current row
      };
    });
  };

  const groupByPreset = (opts = []) => {
    return opts.reduce((acc, opt) => {
      const key = opt.preset_name;
      if (!acc[key]) acc[key] = [];
      acc[key].push(String(opt.option_value));
      return acc;
    }, {});
  };

  const generateSKUs = (grouped) => {
    const values = Object.values(grouped);
    if (!values.length) return [];

    return values
      .reduce((acc, curr) => {
        if (!acc.length) return curr.map(v => [v]);
        return acc.flatMap(a => curr.map(v => [...a, v]));
      }, [])
      .map(sku => sku.join("-"));
  };

  // NEW VALIDATION: Check if all variations have at least one option selected
  const validateConfigurationOptionsCompleteness = (row, rows2, skuAttributes) => {
    // Get all variations from rows2
    const allVariations = rows2
      .filter(r => r.fieldName && r.opts?.length > 0)
      .map(r => ({
        id: r.fieldName,
        name: r.fieldNameLabel,
        required: true // All variations are required to have at least one option selected
      }));

    // Get currently selected options grouped by preset
    const selectedByPreset = {};
    (row.opts || []).forEach(opt => {
      const presetId = String(opt.preset_id || opt.sku_preset_attribute_id);
      if (!selectedByPreset[presetId]) {
        selectedByPreset[presetId] = [];
      }
      selectedByPreset[presetId].push(opt.option_id);
    });

    // Check if each variation has at least one option selected
    const missingVariations = allVariations.filter(variation => {
      const variationId = String(variation.id);
      return !selectedByPreset[variationId] || selectedByPreset[variationId].length === 0;
    });

    if (missingVariations.length > 0) {
      const missingNames = missingVariations.map(v => v.name).join(', ');
      return `Each Variation must have at least one option selected.`;
    }

    return ""; // No error
  };

// Update the validateConfigConflicts function
const validateConfigConflicts = (row, rows = rows3) => {
  let isValid = true;
  const errors = {};

  const currentName = row.configuration_name?.trim().toLowerCase();

  // 🔁 DUPLICATE CONFIGURATION NAME - Show inline error
  if (currentName) {
    const duplicateName = rows.some(r =>
      r.id !== row.id &&
      r.fieldName?.trim().toLowerCase() === currentName
    );

    if (duplicateName) {
      errors.configuration_name = "Configuration Name already exists";
      isValid = false;
    }
  }

  // 🔀 OVERLAPPING CONFIGURATION OPTIONS - CORRECTED LOGIC
  if (row.opts?.length > 0) {
    // Get all variations (presets) from rows2
    const allVariations = rows2
      .filter(r => r.fieldName && r.opts?.length > 0)
      .map(r => ({
        id: String(r.fieldName),
        name: r.fieldNameLabel,
        options: r.opts.map(o => String(o.value))
      }));

    // Get current row's selected options grouped by preset
    const currentSelections = {};
    row.opts.forEach(opt => {
      const presetId = String(opt.preset_id || opt.sku_preset_attribute_id);
      if (!currentSelections[presetId]) {
        currentSelections[presetId] = new Set();
      }
      currentSelections[presetId].add(String(opt.option_id));
    });

    // ✅ FIRST: Check if all variations have at least one option selected
    // (This should take priority over overlapping validation)
    if (rows2.length > 0) {
      const completenessError = validateConfigurationOptionsCompleteness(row, rows2, skuAttributes);
      if (completenessError) {
        errors.configuration_options = completenessError;
        isValid = false;
        
        // Clear overlapping error when we have completeness error
        setRowErrors(prev => {
          const newErrors = { ...prev };
          
          // Clear overlapping error from current row
          if (newErrors[row.id]?.configuration_options && 
              newErrors[row.id].configuration_options.includes("overlapping")) {
            delete newErrors[row.id].configuration_options;
          }
          
          // Clear overlapping errors from all rows when completeness error exists
          Object.keys(newErrors).forEach(rowId => {
            if (newErrors[rowId]?.configuration_options && 
                newErrors[rowId].configuration_options.includes("overlapping")) {
              delete newErrors[rowId].configuration_options;
              if (Object.keys(newErrors[rowId] || {}).length === 0) {
                delete newErrors[rowId];
              }
            }
          });
          
          return newErrors;
        });
        
        // Skip overlapping validation when we have completeness error
        setRowErrors(prev => ({
          ...prev,
          [row.id]: {
            ...prev[row.id],
            ...errors
          }
        }));
        
        return isValid;
      }
    }

    // Generate all possible SKU combinations for current configuration
    const generateAllCombinations = (selections) => {
      // First, get all variation IDs that have options selected
      const variationIds = Object.keys(selections).filter(id => selections[id]?.size > 0);
      
      if (variationIds.length === 0) return [];
      
      // For each variation, get its selected options
      const variationOptionsArrays = variationIds.map(id => 
        Array.from(selections[id])
      );
      
      // Generate Cartesian product of all selected options
      const cartesianProduct = (arrays) => {
        if (arrays.length === 0) return [[]];
        const [first, ...rest] = arrays;
        const restCombinations = cartesianProduct(rest);
        const result = [];
        
        for (const option of first) {
          for (const combination of restCombinations) {
            result.push([option, ...combination]);
          }
        }
        
        return result;
      };
      
      const combinations = cartesianProduct(variationOptionsArrays);
      
      // Create a map of combination strings with variation ID prefixes
      return combinations.map(combo => {
        // Create a string representation like "preset1:option1|preset2:option2"
        return variationIds.map((id, index) => `${id}:${combo[index]}`).join('|');
      });
    };

    const currentCombinations = generateAllCombinations(currentSelections);
    const currentComboSet = new Set(currentCombinations);
    
    // Find all overlapping configurations
    const overlappingRows = [];
    
    // Check each other configuration
    rows.forEach(otherRow => {
      if (otherRow.id === row.id || !otherRow.opts?.length) return;
      
      // Get other row's selected options grouped by preset
      const otherSelections = {};
      otherRow.opts.forEach(opt => {
        const presetId = String(opt.preset_id || opt.sku_preset_attribute_id);
        if (!otherSelections[presetId]) {
          otherSelections[presetId] = new Set();
        }
        otherSelections[presetId].add(String(opt.option_id));
      });

      const otherCombinations = generateAllCombinations(otherSelections);
      const otherComboSet = new Set(otherCombinations);

      // Check for overlapping combinations
      // Two configurations overlap if they share ANY common combination
      let hasOverlap = false;
      for (const combo of currentComboSet) {
        if (otherComboSet.has(combo)) {
          hasOverlap = true;
          break;
        }
      }
      
      // Also check the reverse (though if one has overlap, the other does too)
      if (!hasOverlap) {
        for (const combo of otherComboSet) {
          if (currentComboSet.has(combo)) {
            hasOverlap = true;
            break;
          }
        }
      }

      // If there's any overlap, mark both configurations
      if (hasOverlap) {
        overlappingRows.push(otherRow.id);
      }
    });

    // Show overlapping error on ALL overlapping configurations
    if (overlappingRows.length > 0) {
      // Set error on current row
      errors.configuration_options = `Please remove the overlapping Options`;
      isValid = false;
      
      // Also update errors for all overlapping rows
      setRowErrors(prev => {
        const newErrors = { ...prev };
        
        // Update all overlapping rows
        overlappingRows.forEach(rowId => {
          newErrors[rowId] = {
            ...newErrors[rowId],
            configuration_options: `Please remove the overlapping Options`
          };
        });
        
        return newErrors;
      });
    } else {
      // If no overlaps, clear overlapping error from ALL rows
      setRowErrors(prev => {
        const newErrors = { ...prev };
        
        // Clear overlapping error from current row if it exists
        if (newErrors[row.id]?.configuration_options && 
            newErrors[row.id].configuration_options.includes("overlapping")) {
          delete newErrors[row.id].configuration_options;
          if (Object.keys(newErrors[row.id] || {}).length === 0) {
            delete newErrors[row.id];
          }
        }
        
        // Clear overlapping error from all other rows
        Object.keys(newErrors).forEach(rowId => {
          if (newErrors[rowId]?.configuration_options && 
              newErrors[rowId].configuration_options.includes("overlapping")) {
            delete newErrors[rowId].configuration_options;
            if (Object.keys(newErrors[rowId] || {}).length === 0) {
              delete newErrors[rowId];
            }
          }
        });
        
        return newErrors;
      });
    }
  } else {
    // If row has no options, clear both overlapping and completeness errors
    setRowErrors(prev => {
      const newErrors = { ...prev };
      
      if (newErrors[row.id]?.configuration_options) {
        delete newErrors[row.id].configuration_options;
        if (Object.keys(newErrors[row.id] || {}).length === 0) {
          delete newErrors[row.id];
        }
      }
      
      return newErrors;
    });
  }

  // ✅ UPDATE ERRORS - but preserve existing errors
  setRowErrors(prev => {
    const newErrors = { ...prev };
    
    // Update the current row's errors (except overlapping which was already handled)
    newErrors[row.id] = {
      ...newErrors[row.id],
      ...errors
    };
    
    // If there are no errors for this row, clean up the entry
    if (Object.keys(newErrors[row.id] || {}).length === 0) {
      delete newErrors[row.id];
    }
    
    return newErrors;
  });

  return isValid;
};
// Helper to clean configuration data when variations change
const cleanupConfigurations = () => {
  // Get current valid variations
  const validPresets = rows2
    .filter(r => r.fieldName && r.opts?.length > 0)
    .map(r => String(r.fieldName));
  
  const validOptionIds = new Set();
  rows2.forEach(r => {
    if (r.fieldName && r.opts) {
      r.opts.forEach(opt => {
        validOptionIds.add(String(opt.value));
      });
    }
  });
  
  // Clean up rows3 - remove invalid options
  const cleanedRows3 = rows3.map(row => ({
    ...row,
    opts: row.opts?.filter(opt => {
      const presetId = String(opt.preset_id || opt.sku_preset_attribute_id);
      const optionId = String(opt.option_id);
      return validPresets.includes(presetId) && validOptionIds.has(optionId);
    }) || []
  }));
  
  setRows3(cleanedRows3);
  
  // IMPORTANT: Do NOT clear configuration errors here
  // They should persist until the user fixes them
};
  const [isAddCustomDisabledCf, setIsAddCustomDisabledCf] = useState({});

  useEffect(() => {
    let updateAddCustomFieldsCf = {};

    Object.keys(rowsCf).forEach(cfKey => {
      const rows = rowsCf[cfKey] ?? [];

      if (rows.length === 0) {
        updateAddCustomFieldsCf[cfKey] = true;
        return;
      }

      const lastRow = rows[rows.length - 1];

      updateAddCustomFieldsCf[cfKey] =
        !lastRow.fieldName?.trim() ||
        (lastRow.fieldType === "Text" && !lastRow.value?.trim());
    });

    setIsAddCustomDisabledCf(updateAddCustomFieldsCf);
  }, [rowsCf]);


  const labelMap = {
    model_name: "SPU Name",
    model_id: "ID",
    field_name: "Field Name",
    field_value: "Field Value",
  };


  useEffect(() => {
    return () => {
      uploadedImages.forEach(img => URL.revokeObjectURL(img.preview));
    };
  }, []);  // ← NO dependencies
  const [spuData, setSpuData] = useState(null);


  const handleBrowseClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const MAX_FILE_SIZE = 1024 * 1024; // 1MB
  const ALLOWED_TYPES = ['image/jpeg', 'image/png'];
  const [uploadError, setUploadError] = useState('');
  const validateFiles = (files) => {
    return files.every(
      file =>
        ALLOWED_TYPES.includes(file.type) &&
        file.size <= MAX_FILE_SIZE
    );
  };

  const [formData, setFormData] = useState({

    model_name: '',
    prefix: '',
    model_id: '',
    status: '0',
    product_type: '',
    brand_id: '',
    category_id: '',
    release_date: '',
    images: [],
    customised: [],
    notes: '',
  });

  const [errors, setFormErrors] = useState({
    model_name: '',
    prefix: '',
    brand: '',
    category: ''
  });
  const FIELD_LABELS_BLUR = {
    model_name: "SPU Name",
    brand_id: "Brand",
    category_id: "Category",
    product_type: "Type",
    release_date: "Release Date",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (value && String(value).trim()) {
      setFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleFieldBlur = (e) => {
    const { name, value } = e.target;
    if (!value || !String(value).trim()) {
      const label = FIELD_LABELS_BLUR[name] || name;
      setFormErrors(prev => ({ ...prev, [name]: `${label} is required` }));
    } else {
      setFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };
  const hasRowErrors = (errorsObj) => {
    return Object.values(errorsObj).some(
      rowErr =>
        rowErr &&
        Object.values(rowErr).some(
          msg => typeof msg === "string" && msg.trim() !== ""
        )
    );
  };

  const buildSpuCustomised = () => {
    return rows.map(r => ({
      field_name: r.fieldName || "",
      field_type: r.fieldType || "Text",
      field_data: r.value || ""
    }));
  };

  const FIELD_LABELS = {
    model_name: "SPU Name",
    brand_id: "Brand",
    category_id: "Category",
    product_type: "Type",
    release_date: "Release Date",
  };

  const hasIncompleteRows = (rows) =>
    rows.some(row =>
      !row.fieldName?.trim() ||
      !row.fieldType ||
      !row.value ||
      (Array.isArray(row.value) && row.value.length === 0)
    );


  const validateOnlyIncompleteRows = (rows) => {
    const errors = {};

    rows.forEach(row => {
      const rowErrors = {};

      if (!row.fieldName?.trim()) {
        rowErrors.fieldName = "Field Name is required";
      }

      if (!row.fieldType) {
        rowErrors.fieldType = "Field Type is required";
      }

      if (
        !row.value ||
        (Array.isArray(row.value) && row.value.length === 0)
      ) {
        rowErrors.value = "Field Value is required";
      }

      // ✅ IMPORTANT: set ALL errors at once
      if (Object.keys(rowErrors).length > 0) {
        errors[row.id] = rowErrors;
      }
    });

    return errors;
  };

const handleSaveAndAddToSKU = async () => {
  
  // 🔴 Validate ONLY on Next click
  if (rows.length > 0 && hasIncompleteRows(rows)) {
    const validationErrors = validateOnlyIncompleteRows(rows);
    setRowErrors(validationErrors);
    setAlert({
      type: "error",
      action: "update",
      message: "Please fix the errors below",
    });
    setShowItemAlert(true);
    return;
  }
  if (hasRowErrors(rowErrors)) {
    setAlert({
      type: "error",
      action: "update",
      message: "Please fix the errors below",
    });
    setShowItemAlert(true);
    return;
  }
  setDisabled(true);

  let errors = {};
  let isError = false;

  const requiredFields = ["model_name", "brand_id", "category_id", "product_type", "release_date"];
  requiredFields.forEach(field => {
    if (!formData[field] || !String(formData[field]).trim()) {
      errors[field] = `${FIELD_LABELS[field]} is required`;
      isError = true;
    }
  });

  if (
    isSPUNameDuplicate({
      list: allSpus,
      spuName: formData.model_name,
      brandID: formData.brand_id,
      categoryID: formData.category_id,
      productType: formData.product_type,
      excludeId: Number(id),
    })
  ) {
    errors.model_name = "SPU Name already exists";
    isError = true;
  }

  if (
    formData.model_id &&
    isDuplicate({
      list: allSpus,
      field: "model_id",
      value: formData.model_id,
      excludeId: Number(id),
    })
  ) {
    errors.model_id = "ID already exists";
    isError = true;
  }

  if (isError) {
    setDisabled(false);
    setFormErrors(errors);
    setAlert({
      type: "error",
      action: "update",
      message: "Please fix the errors below",
    });
    setShowItemAlert(true);
    return;
  }

  // 1️⃣ Build customised fields correctly
  const customisedArray = buildSpuCustomised();

  // 2️⃣ Build images for StepData - Keep IDs for existing images
  const imageArray = uploadedImages.map(img => ({
    file: img.file || null,
    preview: img.preview,
    spu_image_name: img.spu_image_name, // This is URL/path for existing, blob for new
    id: img.id, // Keep the ID for existing images
    displayName: img.displayName || (img.spu_image_name ? img.spu_image_name.split('/').pop() : 'Image'),
    isExisting: img.isExisting || false,
  }));

  // 3️⃣ Update global StepData with correct SPU structure
  setStepData(prev => ({
    ...prev,
    spuData: {
      model_name: formData.model_name,
      prefix: formData.prefix,
      model_id: formData.model_id,
      status: Number(formData.status),
      product_type: formData.product_type,
      brand_id: Number(formData.brand_id),
      category_id: Number(formData.category_id),
      release_date: formData.release_date,
      notes: formData.notes,
      customised: customisedArray,
    },
    // Store images separately with their IDs
    spuImages: imageArray,
  }));

  setActiveTab2("sku-variations");
  setDisabled(false);
};



  const validateVariationRowsSync = (rows) => {
    const seen = {};
    let hasError = false;

    const updatedRows = rows.map(row => {
      let variationError = "";
      let variationOptionsError = "";

      // 🔴 Required variation
      if (!row.fieldName) {
        variationError = "SKU Variation is required";
      }
      // 🔴 Duplicate (only later rows)
      else if (seen[row.fieldName]) {
        variationError = "SKU Variation already exists";
      } else {
        seen[row.fieldName] = true;
      }

      // 🔴 Options required
      if (!Array.isArray(row.opts) || row.opts.length === 0) {
        variationOptionsError = "Variation Options are required";
      }

      if (variationError || variationOptionsError) {
        hasError = true;
      }

      return {
        ...row,
        variationError,
        variationOptionsError,
      };
    });

    return { hasError, updatedRows };
  };


const handleSaveAndConfigureSKU = () => {
  // First, clean up configurations BEFORE validation
  cleanupConfigurations();
  
  // Clear any existing row errors before validation
  setRowErrors({});

  // Validate variations (SYNC)
  const { hasError, updatedRows } = validateVariationRowsSync(rows2);

  // Update rows with errors
  setRows2(updatedRows);

  // BLOCK navigation if ANY error
  if (hasError) {
    setAlert({
      type: "error",
      action: "update",
      message: "Please fix the errors below",
    });
    setShowItemAlert(true);
    return; // ⛔ HARD BLOCK
  }

  // Save variations data
  const variations = rows2.map(row => {
    const optionIds = row.opts.map(o => Number(o.value));
    return {
      sku_preset_id: Number(row.fieldName),
      sku_preset_option_ids: optionIds,
      sort_numbers: optionIds.map((_, idx) => idx),
    };
  });

  setStepData(prev => ({
    ...prev,
    skuVariations: { variations },
  }));
  
  // Clear any configuration errors before moving to next step
  // This ensures that overlapping errors from previous step don't block navigation
  setRowErrors({});
  
  setActiveTab2("sku-configurations");
};
  useEffect(() => {
    if (stepData?.skuCodeData?.length) {
      console.log('thihihi',stepData.skuCodeData);
      setSkuCodeRows(stepData.skuCodeData);
    }
  }, [stepData?.skuCodeData]);
  useEffect(() => {
    // Always fetch fresh on mount so edits see the current list of SPU names.
    invalidateSpuNamesCache();
    ensureSpuNamesLoaded().then(data => {
      if (Array.isArray(data)) setAllSpus(data);
      setSpusLoading(false);
    });
  }, []);

  const isDuplicate = ({ field, value, excludeId }) => {
    if (!value?.trim()) return false;

    const normalized = value.trim().toLowerCase();

    return allSpus.some(
      spu =>
        spu.spu_id !== excludeId &&
        String(spu[field] || "").trim().toLowerCase() === normalized
    );
  };


  const isSPUNameDuplicate = ({ spuName, brandID, categoryID, productType, excludeId }) => {

    if (!spuName?.trim()) return false;

    const normalized = spuName.trim().toLowerCase();

    return allSpus.some(
      spu =>
        spu.spu_id !== excludeId &&
        String(spu['model_name'] || "").trim().toLowerCase() === normalized &&
        brandID == spu['brand_id'] &&
        categoryID == spu['category_id'] &&
        productType == spu['product_type']
    );
  };

  const validateLocalDuplicate = (field, value, rowId = null) => {
    if (!value?.trim()) return false;

    let exists = false;

    // 🔍 SPU Name
    if (field === "model_name") {
      // exists = isDuplicate({
      //   list: allSpus,
      //   field: "model_name",
      //   value,
      //   excludeId: Number(id),
      // });
      
      exists = isSPUNameDuplicate({
        list: allSpus,
        spuName: value,
        brandID: formData.brand_id,
        categoryID: formData.category_id,
        productType: formData.product_type,
        excludeId: Number(id),
      });

      if (exists) {
        setFormErrors(prev => ({
          ...prev,
          model_name: "SPU Name already exists",
        }));
      }
    }

    // 🔍 SPU ID
    if (field === "model_id") {
      exists = isDuplicate({
        list: allSpus,
        field: "model_id",
        value,
        excludeId: Number(id),
      });

      if (exists) {
        setFormErrors(prev => ({
          ...prev,
          model_id: "ID already exists",
        }));
      }
    }

    // 🔍 Custom Field Name (row-based)
    if (field === "field_name") {
      exists = rows.some(
        r =>
          r.id !== rowId &&
          r.fieldName?.trim().toLowerCase() === value.trim().toLowerCase()
      );

      if (exists) {
        setFormErrors(prev => ({
          ...prev,
          [rowId]: {
            ...prev[rowId],
            field_name: "Field Name already exists",
          }
        }));
      }
    }

    return exists;
  };

  useEffect(() => {
    console.log("🔥 UPDATED STEP DATA NOW:", stepData);
  }, [stepData]);

  const validateConfigurationsSync = (rows3, rowsCf) => {
    const seenNames = {};
    let hasError = false;

    const updatedRows3 = rows3.map((row) => {
      let configurationError = "";
      let skuPresetsError = "";

      const nameKey = row.fieldName?.trim().toLowerCase();

      // 🔴 Required configuration name
      if (!row.fieldName?.trim()) {
        configurationError = "Configuration Name is required";
        hasError = true;
      }
      // 🔴 Duplicate name (ONLY later rows)
      else if (seenNames[nameKey]) {
        configurationError = "Configuration Name already exists";
        hasError = true;
      } else {
        seenNames[nameKey] = true;
      }

      // 🔴 Configuration options required
      if (!Array.isArray(row.opts) || row.opts.length === 0) {
        skuPresetsError = "Configuration Options are required";
        hasError = true;
      }
      // 🔴 NEW: Check if all variations have at least one option
      else {
        const completenessError = validateConfigurationOptionsCompleteness(row, rows2, skuAttributes);
        if (completenessError) {
          skuPresetsError = completenessError;
          hasError = true;
        }
      }

      return {
        ...row,
        configurationError,
        skuPresetsError,
      };
    });

    // 🔴 BUILD INLINE ERRORS FOR CUSTOM FIELDS
    const cfErrors = {};

    Object.entries(rowsCf).forEach(([tempKey, cfRows]) => {
      if (!Array.isArray(cfRows) || cfRows.length === 0) return;

      cfRows.forEach(cf => {
        const rowErr = {};

        if (!cf.fieldName?.trim()) {
          rowErr.fieldName = "Field Name is required";
        }

        if (!cf.fieldType) {
          rowErr.fieldType = "Field Type is required";
        }

        if (
          cf.value === null ||
          cf.value === undefined ||
          (typeof cf.value === "string" && !cf.value.trim()) ||
          (Array.isArray(cf.value) && cf.value.length === 0)
        ) {
          rowErr.value = "Field Value is required";
        }

        if (Object.keys(rowErr).length > 0) {
          cfErrors[cf.id] = rowErr;
          hasError = true;
        }
      });
    });

    return { hasError, updatedRows3, cfErrors };
  };

const handleSaveConfigurations = () => {
  // If no configurations, allow moving forward
  if (rows3.length === 0) {
    setActiveTab2("sku-code");
    return;
  }
  
  // Don't cleanup automatically - let errors persist
  // cleanupConfigurations();
  
  // Check for row errors
  const hasConfigErrors = Object.keys(rowErrors).some(rowId => {
    const errors = rowErrors[rowId] || {};
    return errors.configuration_name || errors.configuration_options;
  });
  
  if (hasConfigErrors) {
    setAlert({
      type: "error",
      action: "update",
      message: "Please fix the errors below",
    });
    setShowItemAlert(true);
    return;
  }
  
  
  // Validate configuration options completeness
  let hasCompletenessError = false;
  const updatedRows3 = rows3.map(row => {
    if (row.opts && row.opts.length > 0) {
      const completenessError = validateConfigurationOptionsCompleteness(row, rows2, skuAttributes);
      if (completenessError) {
        hasCompletenessError = true;
        return {
          ...row,
          skuPresetsError: completenessError
        };
      }
    }
    return row;
  });

  if (hasCompletenessError) {
    setRows3(updatedRows3);
    setAlert({
      type: "error",
      action: "update",
      message: "Please fix the errors below",
    });
    setShowItemAlert(true);
    return;
  }

  // Validate configurations sync
  const { hasError, updatedRows3: validatedRows3, cfErrors } =
    validateConfigurationsSync(rows3, rowsCf);

  setRows3(validatedRows3);

  if (Object.keys(cfErrors).length > 0) {
    setRowErrors(prev => ({ ...prev, ...cfErrors }));
  }

  if (hasError) {
    setAlert({
      type: "error",
      action: "update",
      message: "Please fix the errors below",
    });
    setShowItemAlert(true);
    return;
  }

  // Build final configurations
  const finalConfigurations = rows3.map((row, idx) => {
    const temp_key = row.configuration_id
      ? `cfg-${row.configuration_id}`
      : row.uniqueKey || `cfg-temp-${idx}`;

    return {
      temp_key,
      configMain: {
        temp_key,
        configuration_name: row.fieldName,
        notes: configNotes[temp_key] || "",
        sku_presets: row.opts.map((opt, order) => ({
          sku_preset_attribute_id: Number(opt.preset_id),
          option_id: Number(opt.option_id),
          sort_number: order
        }))
      },
      images: (configImages[temp_key] || []).map((img, order) => ({
        file: img.file || null,
        preview: img.preview,
        image_order: order
      })),
      custom_fields: (rowsCf[temp_key] || []).map(cf => ({
        field_name: cf.fieldName,
        field_type: cf.fieldType,
        field_data: cf.value
      }))
    };
  });

  // Save into stepData
  setStepData(prev => ({
    ...prev,
    skuConfigurationsData: {
      configurations: rows3.map(row => ({
        id: row.configuration_id || Number(row.temp_key?.replace("cfg-", "")) || null,
        temp_key: row.temp_key || row.uniqueKey || `cfg-temp-${row.id}`,
        configuration_name: row.fieldName,
        notes: configNotes[row.temp_key] || "",
        options: row.opts.map(o => ({
          sku_preset_attribute_id: Number(o.sku_preset_attribute_id),
          option_id: Number(o.option_id)
        }))
      })),
      configurationImages: configImages,
      configurationCustomFields: rowsCf,
    }
  }));

  setActiveTab2("sku-code");
};

  const [categoryHierarchy, setCategoryHierarchy] = useState([]);
  const normalizeExistingSkuRows = (existingSkuRows = []) => {
    return existingSkuRows.map(sku => {
      const values = {};

      (sku.attribute_configurations || []).forEach(ac => {
        values[String(ac.sku_preset_attribute_id)] =
          Number(ac.sku_preset_option_id);
      });

      return {
        ...sku,
        values, // 🔥 reconstructed
      };
    });
  };
  function normalizeValues(obj = {}) {
    return Object.keys(obj)
      .sort()
      .reduce((acc, key) => {
        acc[String(key)] = String(obj[key]);
        return acc;
      }, {});
  }
  function applySkuScheme(scheme, data) {
    if (!scheme) return "";

    return scheme.replace(
      /\{(\w+)\}/g,
      (_, key) => data[key] ?? ""
    );
  }

 function generateCombinationsFromVariations(
  rows2Data,
  skuAttributeOptions,
  existingSkuRows = []
) {
  if (!rows2Data?.length || !stepData?.spuData) return [];

  const { spuData } = stepData;
  
  const rule = productType.find(r => r.product_type === spuData.product_type);
  const scheme = rule?.scheme || "";

  const brandPrefix = brands.find(b => b.brand_id === spuData.brand_id)?.prefix || "";
  const categoryPrefix = categories.find(c => c.category_id === spuData.category_id)?.prefix || "";
  const spuPrefix = spuData.prefix || "";

  const variations = rows2Data
    .filter(r => r.fieldName && r.opts?.length)
    .map(r => ({
      attributeId: String(r.fieldName),
      attributeName: r.fieldNameLabel,
      options: r.opts.map(o => ({
        id: String(o.value),
        name: o.label
      }))
    }));

  if (!variations.length) return [];

  // Cartesian product
  let combinations = [{}];
  variations.forEach(v => {
    const temp = [];
    combinations.forEach(c => {
      v.options.forEach(o => {
        temp.push({ ...c, [v.attributeId]: o.id });
      });
    });
    combinations = temp;
  });

  const generatedCombos = combinations.map((combo, index) => {
    const values = {};
    const nameParts = [];
    const orderedValues = [];

    variations.forEach(v => {
      const optionId = combo[v.attributeId];
      values[v.attributeId] = optionId;
      orderedValues.push(optionId);

      const opt = v.options.find(o => o.id === optionId);
      if (opt) nameParts.push(opt.name);
    });

    let skuAbbr = "";
    variations.forEach(v => {
      const optionId = values[v.attributeId];
      if (optionId) {
        const matchedAbbr = skuAttr.find(a => 
          String(a.sku_preset_option_id) === String(optionId)
        );
        
        if (matchedAbbr) {
          let abbreviationOrName = (matchedAbbr.sku_preset_option_abbreviation && 
            matchedAbbr.sku_preset_option_abbreviation.trim() !== '') 
            ? matchedAbbr.sku_preset_option_abbreviation.trim() 
            : matchedAbbr.sku_preset_option_name;
          skuAbbr += abbreviationOrName.replace(/[-\s]/g, '');
        } else {
          const option = v.options.find(o => o.id === optionId);
          if (option) {
            skuAbbr += option.name.replace(/[-\s]/g, '');
          }
        }
      }
    });

    // 🔥 UPDATED MATCHING LOGIC
    const existing = existingSkuRows.find(r => {
      if (!r.values) return false;

      const existingKeys = Object.keys(r.values);
      const comboKeys = Object.keys(values);

      // All keys must be the same set
      const sameKeys = 
        existingKeys.length === comboKeys.length &&
        existingKeys.every(k => comboKeys.includes(k));

      if (!sameKeys) return false;

      // All values must match
      return existingKeys.every(key =>
        String(r.values[key]) === String(values[key])
      );
    });

    const skuCode = applySkuScheme(scheme, {
      BrandPrefix: brandPrefix,
      CategoryPrefix: categoryPrefix,
      SPUPrefix: spuPrefix,
      SKUAbbr: skuAbbr,
    });

    return {
      sku_id: existing ? existing.sku_id : null,
      id: existing?.id ?? index + 1,
      name: existing?.name ?? nameParts.join("-"),
      sku_code: existing?.sku_code ?? skuCode,
      status: existing?.status ?? "1",
      gtin: existing?.gtin ?? "",
      msrp: existing?.msrp ?? "",
      model_number: existing?.model_number ?? "",
      sim_option: existing?.sim_option ?? "",
      values,
      variationNames: variations.map(v => v.attributeName),
      _open: existing?._open ?? false,
      _dropdownPos: existing?._dropdownPos ?? null,
    };
  });

  // 🔥 APPEND UNMATCHED EXISTING SKUs (e.g. old SKUs with different variation set)
  const matchedSkuIds = new Set(
    generatedCombos.filter(c => c.sku_id).map(c => c.sku_id)
  );

  const unmatchedExisting = existingSkuRows.filter(r =>
    r.sku_id && !matchedSkuIds.has(r.sku_id)
  );

  return [...generatedCombos, ...unmatchedExisting];
}

  const prevRows3 = useRef(rows3);

  const [isInitialLoad, setIsInitialLoad] = useState(true);

// Update the useEffect that fetches SPU data
useEffect(() => {
  async function fetchAllData() {
    try {
      console.log("🔥 Starting Full Fetch Sequence...");

      // ==========================================
      // 1️⃣ FETCH SKU ATTRIBUTES
      // ==========================================
      const attrRes = await apiHelper('settings/sku-attributes/', 'GET');
      const attrJson = attrRes.ok ? await attrRes.json() : [];

      const mappedAttributes = attrJson.map(preset => ({
        id: preset.sku_preset_id,
        name: preset.sku_preset_name,
        options: (preset.options || []).map(o => ({
          value: o.sku_preset_option_id,
          label: o.sku_preset_option_name,
        }))
      }));

      setSkuAttributes(mappedAttributes);

      // Build skuAttributeOptions from the attributes data
      const allOptions = mappedAttributes.flatMap(attr =>
        (attr.options || []).map(opt => ({
          option_id: opt.value,
          option_value: opt.label,
          attribute: attr.id
        }))
      );
      setSkuAttributeOptions(allOptions);

      // ==========================================
      // 3️⃣ FETCH BRANDS
      // ==========================================
      const brandRes = await apiHelper('inventory/brands/?is_archived=false&status=true');
      const brandJson = brandRes.ok ? await brandRes.json() : [];
      setBrands(brandJson);

      // ==========================================
      // 4️⃣ FETCH CATEGORIES
      // ==========================================
      const catRes = await apiHelper('inventory/categories/?is_archived=false&status=true');
      const catJson = catRes.ok ? await catRes.json() : [];

      setCategories(catJson);
      const fullHierarchy = getAllHierarchies(catJson);
      setCategoryHierarchy(fullHierarchy);
      
      // ==========================================
      // 5️⃣ FETCH SKU CODE GENERATION RULES
      // ==========================================
      const res = await apiHelper("settings/sku-code-generation-rules/list/", "GET");
      const result = res.ok ? await res.json() : [];
      setProductType(result);

      const response = await apiHelper('settings/sku-attributes-abbrevations/', 'GET');
      let data = await response.json();
      setSkuAttr(data);

      async function fetchSpuData() {
        const response = await apiHelper(`inventory/spu-sku/full/${id}/`, "GET");
        if (!response || !response.ok) return;

        const result = await response.json();

        /* --------------------------------------------------------
           1️⃣ PREFILL SPU FORM
        -------------------------------------------------------- */
        setFormData({
          model_name: result.model_name || "",
          model_id: result.model_id || "",
          prefix: result.prefix || "",
          status: result.status === "Active" ? 1 : 0,
          product_type: result.product_type || "",
          brand_id: result.brand_id,
          category_id: result.category_id,
          release_date: result.release_date,
          notes: result.notes || "",
        });

        /* --------------------------------------------------------
           2️⃣ PREFILL SPU IMAGES - FIXED
        -------------------------------------------------------- */
        const spuImagesUI = (result.images || []).map((img) => ({
          id: img.spu_image_id,
          file: null,
          preview: img.spu_image_name, // This is the URL/path to the image
          spu_image_name: img.spu_image_name, // Store the URL/path
          displayName: img.user_image_name ? img.user_image_name : 'Image',
          isExisting: true, // Mark as existing image
        }));
        setUploadedImages(spuImagesUI);

        /* --------------------------------------------------------
           3️⃣ PREFILL SPU CUSTOM FIELDS
        -------------------------------------------------------- */
        const customFieldRows = (result.custom_fields || []).map((cf, idx) => ({
          id: idx + 1,
          fieldName: cf.field_name,
          fieldType: cf.field_type,
          value: cf.field_data,
        }));
        setRows(customFieldRows);

        /* --------------------------------------------------------
           4️⃣ PREFILL SKU VARIATIONS (Rows2)
        -------------------------------------------------------- */
        const variationRows = (result.sku_preset_attributes || []).map(
          (preset, index) => ({
            id: index + 1,
            fieldName: String(preset.preset_id),
            fieldNameLabel: preset.preset_name,
            opts: preset.options.map((opt) => ({
              value: String(opt.option_id),
              label: opt.option_value,
            })),
          })
        );
        setRows2(variationRows);

        /* --------------------------------------------------------
           5️⃣ PREFILL CONFIGURATIONS (Rows3)
        -------------------------------------------------------- */
        const configurations = result.configurations || [];
        const configImagesMap = {};

        configurations.forEach((cfg) => {
          const key = `cfg-${cfg.sku_configuration_id}`;
          configImagesMap[key] = (cfg.images || []).map((img) => ({
            id: img.sku_configuration_image_id,
            file: null,
            preview: img.sku_image_name,
            spu_image_name: img.sku_image_name,
            displayName: img.user_image_name ? img.user_image_name : 'Image',
            user_image_name: img.user_image_name || '',
            isExisting: true,
          }));
        });

        setConfigImages(configImagesMap);

        // Build rows3 with backend combinations
        const configurationRows = configurations.map((cfg, index) => {
          const tempKey = `cfg-${cfg.sku_configuration_id}`;

          // Extract backend combinations for this configuration
          const backendCombinations = (result.skus || [])
            .filter(
              (s) => s.configuration?.sku_configuration_id === cfg.sku_configuration_id
            )
            .map((sku) => ({
              sku_id: sku.sku_id,
              values: sku.attribute_configurations.reduce((acc, ac) => {
                (ac.options || []).forEach((o) => {
                  acc[o.preset_id] = o.option_id;
                });
                return acc;
              }, {}),
              sku_code: sku.sku_code,
              name: sku.sku_name,
              status: sku.status ? "1" : "0",
              gtin: sku.gtin,
              msrp: sku.msrp,
            }));

          return {
            id: index + 1,
            configuration_id: cfg.sku_configuration_id,
            temp_key: tempKey,
            uniqueKey: tempKey,
            fieldName: cfg.configuration_name,
            notes: cfg.notes || null,

            opts: (cfg.options || []).map((opt) => ({
              sku_preset_attribute_id: Number(opt.preset_id),
              preset_name: opt.preset_name,
              option_id: Number(opt.option_id),
              option_value: opt.option_value,
            })),

            images: (cfg.images || []).map((img) => ({
              id: img.sku_configuration_image_id,
              file: null,
              preview: img.sku_image_name,
              spu_image_name: img.sku_image_name,
              displayName: img.user_image_name ? img.user_image_name : 'Image',
              user_image_name: img.user_image_name || '',
              isExisting: true,
            })),

            combinations: backendCombinations.length ? backendCombinations : [],
          };
        });

        setRows3(configurationRows);

        /* --------------------------------------------------------
           6️⃣ CONFIGURATION CUSTOM FIELDS
        -------------------------------------------------------- */
        const configCustomFields = {};
        configurations.forEach((cfg) => {
          const key = `cfg-${cfg.sku_configuration_id}`;
          configCustomFields[key] = (cfg.custom_fields || []).map((cf, idx) => ({
            id: idx + 1,
            fieldName: cf.field_name,
            fieldType: cf.field_type,
            value: cf.field_data,
          }));
        });
        setRowsCf(configCustomFields);

        /* --------------------------------------------------------
           7️⃣ PREFILL SKU CODE TABLE
        -------------------------------------------------------- */
        const prefilledSkuRows = (result.skus || []).map(sku => ({
          sku_id: sku.sku_id,
          sku_code: sku.sku_code,
          name: sku.sku_name || "",
          status: sku.enable_display ? "1" : "0",
          gtin: sku.gtin || "",
          msrp: sku.msrp || "",
          model_number: sku.model_number || "",
          sim_option: sku.sim_option || "",
          values: sku.values || {},
          variationNames: (result.sku_preset_attributes || []).map(a => a.preset_name),
          _open: false,
          _dropdownPos: null,
        }));

        setSkuCodeRows(prefilledSkuRows);
        originalSkuRowsRef.current = prefilledSkuRows;

        /* --------------------------------------------------------
           8️⃣ BUILD STEP DATA FOR SAVE
        -------------------------------------------------------- */
        const fullStepData = {
          spuData: {
            model_name: result.model_name,
            model_id: result.model_id,
            prefix: result.prefix,
            notes: result.notes,
            status: result.status === "Active" ? 1 : 0,
            product_type: result.product_type,
            brand_id: result.brand_id,
            category_id: result.category_id,
            release_date: result.release_date,
            customised: (result.custom_fields || []).map((cf) => ({
              field_name: cf.field_name,
              field_type: cf.field_type,
              field_data: cf.field_data,
            })),
          },
          // Store images separately with their IDs
          spuImages: spuImagesUI,
          skuVariations: {
            variations: (result.sku_preset_attributes || []).map((attr) => ({
              attribute_id: attr.preset_id,
              option_values: attr.options.map((o) => Number(o.option_id)),
            })),
          },
          skuConfigurationsData: {
            configurations: configurations.map((cfg) => ({
              id: cfg.sku_configuration_id,
              temp_key: `cfg-${cfg.sku_configuration_id}`,
              configuration_name: cfg.configuration_name,
              notes: cfg.notes || "",
              options: cfg.options.map(o => ({
                sku_preset_attribute_id: Number(o.preset_id),
                option_id: Number(o.option_id),
              })),
            })),
            configurationImages: configurationRows.reduce((acc, cfg) => {
              acc[cfg.temp_key] = cfg.images;
              return acc;
            }, {}),
            configurationCustomFields: configCustomFields,
          },
          skuCodeData: (result.skus || []).map((sku, index) => ({
            sku_id: sku.sku_id,
            sku_code: sku.sku_code,
            name: sku.sku_name || "",
            status: sku.enable_display ? "1" : "0",
            gtin: sku.gtin || "",
            msrp: sku.msrp || "",
            model_number: sku.model_number || "",
            sim_option: sku.sim_option || "",
            values: sku.values || {},
            variationNames: (result.sku_preset_attributes || []).map(a => a.preset_name)
          }))
        };

        setStepData(fullStepData);
        console.log("🔥 FULL EDIT MODE STEPDATA BUILT:", fullStepData);
      }

      await fetchSpuData();
      setIsInitialLoad(false);

      console.log("⭐ ALL DATA COMPLETED SUCCESSFULLY ⭐");

    } catch (error) {
      console.error("❌ FATAL FETCH ERROR:", error);
    }
  }

  fetchAllData();
}, [id]);

  const productTabs = rows3.map(cfg => {
    const tempKey =
      cfg.configuration_id
        ? `cfg-${cfg.configuration_id}`
        : cfg.uniqueKey || `cfg-temp-${cfg.id}`;

    return {
      key: tempKey,
      label: cfg.fieldName,
    };
  });


  useEffect(() => {
    if (productTabs.length > 0 && !activeTab) {
      setActiveTab(productTabs[0].key);
    }
  }, [productTabs]);


 const makeImageObjects = (files, existingCount = 0) => {
  return files
    .map(file => ({
      id: Date.now() + Math.random(),
      file,
      preview: URL.createObjectURL(file),
      user_image_name: file.name
    }));
};
const handleImageChange = (e) => {
  setIsDirty(true);
  const files = Array.from(e.target.files || []);

  if (!files.length) return;

  const isValid = validateFiles(files);

  if (!isValid) {
    setUploadError( 'Upload failed — Only JPEG/PNG files below 1MB are supported');
    e.target.value = ''; // reset input
    return;
  }

  setUploadError('');
  
  // Create proper image objects with correct preview and filename
  const newImgs = files.map(file => {
    const preview = URL.createObjectURL(file);
    return {
      id: Date.now() + Math.random(), // Temporary ID for new images
      file,
      preview,
      spu_image_name: preview, // Temporary preview URL
      displayName: file.name, // Store the actual filename for display
      user_image_name: file.name,
      isExisting: false, // Mark as new image
    };
  });
  
  setUploadedImages(prev => [...prev, ...newImgs]);
};

// Update handleDrop function
const handleDrop = (e) => {
  setIsDirty(true);
  e.preventDefault();
  setIsDragging(false);

  const files = Array.from(e.dataTransfer.files || []);

  if (!files.length) return;

  const isValid = validateFiles(files);

  if (!isValid) {
    setUploadError(
      'Upload failed — Only JPEG/PNG files below 1MB are supported'
    );
    return;
  }

  setUploadError('');
  
  // Create proper image objects with correct preview and filename
  const newImgs = files.map(file => {
    const preview = URL.createObjectURL(file);
    return {
      id: Date.now() + Math.random(), // Temporary ID for new images
      file,
      preview,
      spu_image_name: preview, // Temporary preview URL
      displayName: file.name, // Store the actual filename for display
      isExisting: false, // Mark as new image
    };
  });
  
  setUploadedImages(prev => [...prev, ...newImgs]);
};

// Update handleRemove function
const handleRemove = (id) => {
  setIsDirty(true);
  setUploadedImages(prev => {
    const img = prev.find(x => x.id === id);
    if (img && img.preview && img.preview.startsWith('blob:')) {
      URL.revokeObjectURL(img.preview);
    }
    return prev.filter(x => x.id !== id);
  });
};


  const formatSize = size => {
    const mb = size / (1024 * 1024);
    return `${mb.toFixed(1)}mb`;
  };
  const [showItemAlert, setShowItemAlert] = useState(false);

  const handleDiscard = () => {
    console.log("❌ handleDiscard CALLED");

    if (isDiscardingRef.current) return;

    isDiscardingRef.current = true;
    setDiscardModalOpen(true);
  };

  const handleDiscardConfirm = () => {
    console.log("✅ Discard confirmed");

    // 🔥 HARD DISABLE UnsavedChangesPrompt
    isDiscardingRef.current = true;

    setDiscardModalOpen(false);
    setIsDirty(false);

    history.push("/spu-sku", {
      success: "SPU & SKU Discarded Successfully",
    });
  };

  const handleCancelDiscard = () => {
    console.log("❌ Discard cancelled");

    isDiscardingRef.current = false;
    setDiscardModalOpen(false);
  };


  const [isOsTypeOpen, setIsOsTypeOpen] = useState(false);
  const [osTypeSearch, setOsTypeSearch] = useState('');

  const [justOpened, setJustOpened] = useState(false); //for category
  const [justOpenedType, setJustOpenedType] = useState(false); //for type
  
  const osTypeRef = useRef(null);
  // const filteredOsTypes = productType.filter((item) =>
  //   item.product_type
  //     ?.toLowerCase()
  //     .includes(osTypeSearch.toLowerCase())
  // );
  const filteredOsTypes = productType.filter((item) => {
    if (justOpenedType) return true;   // show ALL on first open

    const search = (osTypeSearch || "").toLowerCase();
    return item.product_type?.toLowerCase().includes(search);
  });


  // Select an option
  const handleOsTypeSelect = (val) => {
    setFormData(prev => ({ ...prev, product_type: val }));
    setOsTypeSearch(val);
    setIsOsTypeOpen(false);
    if (val?.toLowerCase() !== 'device') {
      setSkuCodeRows(prev =>
        prev.map(r => ({ ...r, sim_option: '', simOptionError: '' }))
      );
    }
  };
  useEffect(() => {
    if (formData.product_type) {
      setOsTypeSearch(formData.product_type);   // show selected value in input
    }
  }, [formData.product_type]);


  const [selectedCompatibility, setSelectedCompatibility] = useState([]);
  const [isCompatibilityOpen, setIsCompatibilityOpen] = useState(false);
  const [compatibilitySearch, setCompatibilitySearch] = useState('');

  const compatibilityRef = useRef(null);
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      compatibility: selectedCompatibility.map((item) => item.id)
    }));
  }, [selectedCompatibility]);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isCompatibilityOpen &&
        compatibilityRef.current &&
        !compatibilityRef.current.contains(e.target)
      ) {
        setIsCompatibilityOpen(false);
      }
      if (isCategoryOpen && categoryRef.current && !categoryRef.current.contains(e.target)) {
        setIsCategoryOpen(false);
      }
      if (isOsTypeOpen && osTypeRef.current && !osTypeRef.current.contains(e.target)) {
        setIsOsTypeOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isCompatibilityOpen, isCategoryOpen,isOsTypeOpen]);

  

  const [activeTab2, setActiveTab2] = useState('edit-spu');
  const breadcrumbs = ["Product", "SPU & SKU", "Edit SPU & SKU"];

  const [rows, setRows] = useState([
    {
      id: 1, fieldName: 'OS Type',
      fieldType: 'Text',      // or 'Reference'
      refChild: '',           // one of REFERENCE_CHILDREN
      value: 'iOS',              // for Text
      opts: [],               // for multi‑select
      typeOpen: false,        // dropdown open?
      refMenuOpen: false,     // submenu open?
      isOpen: false,          // multi‑select open?
      search: ''              // multi‑select search
    },
    {
      id: 2, fieldName: 'Compatible Devices',
      fieldType: 'Text',
      refChild: '',
      value: '',
      opts: [],
      typeOpen: false,
      refMenuOpen: false,
      isOpen: false,
      search: ''
    }
  ]);
  const rowRefs = useRef({});

  const addRow = () => {
    setIsDirty(true);
    const newId = rows.length ? Math.max(...rows.map(r => r.id)) + 1 : 1;
    setRows([...rows, { id: newId, fieldName: '', fieldType: 'Text', refChild: '', value: '', opts: [], typeOpen: false, refMenuOpen: false, isOpen: false, search: '' }]);
  };
  const deleteRow = id => setRows(rows.filter(r => r.id !== id));
  const deleteSpuRow = id => {
    setIsDirty(true);
    setRows(prev => prev.filter(r => r.id !== id));

    setRowErrors(prev => {
      if (!prev[id]) return prev;

      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const updateRowBulk = (id, changes) => {
    setIsDirty(true);
    setRows(rows.map(r => r.id === id ? { ...r, ...changes } : r));
  };
  
  useEffect(() => {
    if (isCategoryOpen) {
      const selectedName =
        categoryHierarchy.find(c => c.id === formData.category_id)?.name || "";

      setTempParentCategorySearchTerm(selectedName);
      setJustOpened(true);
    }
  }, [isCategoryOpen]);

  useEffect(() => {
    if (isOsTypeOpen) {
      setOsTypeSearch(
        formData.product_type || ""
      );
      setJustOpenedType(true);
    }
  }, [isOsTypeOpen]);




  // Close dropdowns on outside click
  useEffect(() => {
    const handler = e => {
      const inPortal = portalRoot?.contains(e.target);
      setRows(rs => rs.map(r => {
        const el = rowRefs.current[r.id]?.current;
        if (!inPortal && el && !el.contains(e.target)) {
          return { ...r, typeOpen: false, refMenuOpen: false, isOpen: false };
        }
        return r;
      }));
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const [showMissingSku, setShowMissingSku] = useState(true);
  const [showTable, setShowTable] = useState(false);


  // inside your component, after your useState:
  useEffect(() => {
    if (rows.length === 0) {
      setShowMissingSku(true);
    }
  }, [rows.length]);

  const archivedRef = useRef(null);
  const [archivedModalOpen, setArchivedModalOpen] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null); // optional

  const handleArchivedConfirm = () => {
    setArchivedModalOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (archivedRef.current && !archivedRef.current.contains(event.target)) {
        setArchivedModalOpen(false);
      }
    }

    if (archivedModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [archivedModalOpen]);


  const [rows2, setRows2] = useState([]);
  const rowRefs2 = useRef({});
  const [showMissingVar, setShowMissingVar] = useState(true);

  // show alert if no rows
  useEffect(() => {
    if (rows2.length === 0) setShowMissingVar(true);
  }, [rows2.length]);


  function addRow2() {
    setIsDirty(true);
    const newId = rows2.length ? Math.max(...rows2.map(r => r.id)) + 1 : 1;
    const usedAttributes = rows2.map(r => r.fieldName).filter(Boolean);
    const availableAttribute = skuAttributes.find(
      attr => !usedAttributes.includes(attr.id.toString())
    );
    const newRow = {
      id: newId,
      fieldName: '',
      opts: [],
      isOpen: false,
      search: '',
    };
    setRows2([...rows2, newRow]);
  }

  const deleteRow2 = id => {
    setIsDirty(true); 
    setRows2(rows2.filter(r => r.id !== id));
  };

  const updateRow2 = (id, changes) => {
    setIsDirty(true);  // ← add this
    setRows2(rows2.map(r => (r.id === id ? { ...r, ...changes } : r)));
  };

  // close dropdowns on outside click
  useEffect(() => {
    const handler = e => {
      const inPortal = portalRoot?.contains(e.target);
      setRows2(rs =>
        rs.map(r => {
          const el = rowRefs2.current[r.id]?.current;
          if (!inPortal && el && !el.contains(e.target)) {
            return { ...r, isOpen: false };
          }
          return r;
        })
      );
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);


  const addRow3 = () => {
    setIsDirty(true);
    const newId = rows3.length ? Math.max(...rows3.map(r => r.id)) + 1 : 1;
    setRows3([...rows3, { id: newId, fieldName: '', opts: [], isOpen: false }]);
  };

  const deleteRow3 = id => {
    setIsDirty(true); 
    setRows3(rows3.filter(r => r.id !== id));
    setRowErrors((prev) => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
    });
  };

  const updateRow3 = (id, changes) => {
    setIsDirty(true); 
    // setRows3(rows3.map(r => (r.id === id ? { ...r, ...changes } : r)));
    setRows3((prev) =>
      prev.map((r) =>
        r.id === id
          ? { ...r, ...changes }
          : r
      )
    );
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handler = e => {
      const inPortal = portalRoot?.contains(e.target);
      setRows3(rs =>
        rs.map(r => {
          const el = rowRefs3.current[r.id]?.current;
          if (!inPortal && el && !el.contains(e.target)) {
            return { ...r, isOpen: false };
          }
          return r;
        })
      );
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const currentRowsEmpty =
    activeTab2 === "edit-spu"
      ? false                                     // 🔥 SPU TAB NEXT ALWAYS ENABLED
      : activeTab2 === "sku-variations"
        ? rows2.length === 0
        : activeTab2 === "sku-configurations"
          ? rows3.length === 0
          : skuCodeRows.length === 0;


  const [showMissingCfg, setShowMissingCfg] = useState(true);

  // reset the alert whenever rows3 goes to zero
  useEffect(() => {
    if (rows3.length === 0) {
      setShowMissingCfg(true);
    }
  }, [rows3.length]);

  //Tab 3 same data of input field alert box code
  const stepMapping = {
    "edit-spu": 1,
    "sku-variations": 2,
    "sku-configurations": 3,
    "sku-code": 4
  };


  const tabContent = {
    'edit-spu': {
      heading: "SPU",
      buttons: ["discard", "next"]
    },
    'sku-variations': {
      heading: "SKU Variations",
      buttons: ["discard", "back", "next"]
    },
    'sku-configurations': {
      heading: "SKU Configurations",
      buttons: ["discard", "back", "next"]
    },
    'sku-code': {
      heading: "SKU Info",
      buttons: ["discard", "back", "save"]
    }
  };

  const dateRef = useRef(null);

  // new state for the "exists" alert
  const [showCfgExists, setShowCfgExists] = useState(false);
  const currentTab = tabContent[activeTab2];
  useEffect(() => {
    const names = rows3.map(r => r.fieldName.trim()).filter(n => n);
    const hasDup = names.some((n, i) => names.indexOf(n) !== i);
    setShowCfgExists(hasDup);
  }, [rows3]);

  const [productTab, setProductTab] = useState('white-iphone-16-pro-max');

  //Tab 3 product info tabs code below
  const [activeTab, setActiveTab] = useState(null);
  const [overflowTabs, setOverflowTabs] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuStyles, setMenuStyles] = useState({ top: 0, left: 0, direction: "down" });
  const containerRef = useRef(null);
  const triggerRef = useRef(null);
  const tabRefs = useRef({});

  function calcOverflow() {
    if (!containerRef.current) return;
    const contW = containerRef.current.clientWidth;
    const trigW = triggerRef.current?.offsetWidth || 40;
    let used = 0;
    const vis = [];
    const over = [];

    productTabs.forEach(tab => {
      const btn = tabRefs.current[tab.key];
      if (!btn) return;
      const w = btn.offsetWidth;
      if (tab.key === activeTab || used + w < contW - trigW) {
        vis.push(tab.key);
        used += w;
      } else {
        over.push(tab.key);
      }
    });

    setOverflowTabs(over);
  }

  // measure before paint so icon is in right place
  useLayoutEffect(() => {
    // Delay 1 frame to ensure refs are ready
    requestAnimationFrame(() => {
      calcOverflow();
      scrollActiveTabIntoView();
    });
  }, [activeTab]);

  function scrollActiveTabIntoView() {
    const activeEl = tabRefs.current[activeTab];
    if (activeEl && containerRef.current) {
      activeEl.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });
    }
  }


  // recalc on resize
  useEffect(() => {
    window.addEventListener("resize", calcOverflow);
    return () => window.removeEventListener("resize", calcOverflow);
  }, []);

  function toggleMenu(e) {
    if (!triggerRef.current) return;
    // const rect = triggerRef.current.getBoundingClientRect();
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const direction = spaceBelow < 200 ? "up" : "down";

    const prevEl = e.currentTarget.previousElementSibling;
    if (!prevEl) return;
    const prevElRect = prevEl.getBoundingClientRect();
    const prevElWidth = prevElRect.width;
    const prevElLeft = prevElRect.left + window.scrollX;
    
    setMenuStyles({
      width: '120',
      top: direction === "down" ? rect.bottom + window.scrollY : rect.top + window.scrollY,
      // left: prevElLeft, // rect.right + window.scrollX - 200, // 200 = approx menu width
      right: '50',
      direction
    });
    setMenuOpen(open => !open);
  }

  useEffect(() => {
    if (!menuOpen) return;

    const handleClickOutside = (e) => {
      setMenuOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  // render the portal menu
  const portalMenu = menuOpen && createPortal(
    <ul
      className={`pt-portal-menu ${menuStyles.direction}`}
      style={{
        position: "absolute",
        top: `${menuStyles.top}px`,
        right: `${menuStyles.right}px`,
        width: `${menuStyles.width}px`,
      }}
    >
      {productTabs.map(tab => (
        <li key={tab.key}>
          <button
            className={`pt-portal-item ${activeTab === tab.key ? "selected" : ""}`}
            onClick={() => {
              setActiveTab(tab.key);
              setMenuOpen(false);
            }}
          >
            {tab.label}
          </button>
        </li>
      ))}
    </ul>,
    document.body
  );

  const handleChangeWithDirty = (e) => {
    setIsDirty(true);
    handleChange(e);
  };
  const [skuVariations, setSkuVariations] = useState([]);
  const [skuConfigurations, setSkuConfigurations] = useState([]);
  const [skuCode, setSkuCode] = useState({});

  const saveLocal = () => {
    const draft = {
      formData,
      variations: skuVariations,      // ← Use the real variable name
      configurations: skuConfigurations, // ← Use actual name
      skuCodeData: skuCode,           // ← Use actual name
    };

    localStorage.setItem("spuDraft", JSON.stringify(draft));
  };

  const buildCategoryMap = (categories) => {
    const map = new Map();
    categories.forEach(cat => map.set(cat.category_id, cat));
    return map;
  };
  const getFullHierarchy = (category, map) => {
    const chain = [];
    let current = category;

    while (current) {
      chain.push({
        id: current.category_id,
        name: current.category_name,
      });

      if (!current.parent_category) break;

      current = map.get(current.parent_category); // climb up
    }

    return chain; // bottom-up
  };
  const getAllHierarchies = (categories) => {
    const map = buildCategoryMap(categories);

    return categories.map(cat => ({
      id: cat.category_id,
      name: cat.category_name,
      hierarchy: getFullHierarchy(cat, map),
    }));
  };

  const getHierarchyString = (item) => {
    if (!item?.hierarchy || item.hierarchy.length === 0) return "";
    // hierarchy is built bottom-up [self, parent, grandparent, ...]
    // Reverse to get top-down [root, ..., parent, self] — matches API category_hierarchy
    return [...item.hierarchy].reverse().map(p => p.name).join(" >> ");
  };
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null); // "asc" | "desc"

const handleSort = (field) => {
  if (sortField === field) {
    // toggle asc/desc
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  } else {
    setSortField(field);
    setSortOrder("asc"); // default sort order
  }
};

const sortedSkuCodeRows = useMemo(() => {
  if (!sortField || !sortOrder) return skuCodeRows;

  return [...skuCodeRows].sort((a, b) => {
    const aVal = a?.[sortField] ?? "";
    const bVal = b?.[sortField] ?? "";

    // Handle different data types
    if (sortField === 'status') {
      // Convert status to display string for sorting
      const aStatus = aVal === '1' ? 'YES' : 'NO';
      const bStatus = bVal === '1' ? 'YES' : 'NO';
      return sortOrder === "asc" 
        ? aStatus.localeCompare(bStatus)
        : bStatus.localeCompare(aStatus);
    }
    
    if (sortField === 'msrp') {
      // Numeric sort for MSRP
      const aNum = parseFloat(aVal) || 0;
      const bNum = parseFloat(bVal) || 0;
      return sortOrder === "asc" ? aNum - bNum : bNum - aNum;
    }
    
    // Default string sort for other fields (name, sku_code, gtin)
    const aStr = String(aVal).toLowerCase();
    const bStr = String(bVal).toLowerCase();
    
    return sortOrder === "asc" 
      ? aStr.localeCompare(bStr)
      : bStr.localeCompare(aStr);
  });
}, [skuCodeRows, sortField, sortOrder]);

  const totalItems = sortedSkuCodeRows.length;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, totalItems);
  const paginatedRows = sortedSkuCodeRows.slice(startIndex, endIndex);


  useEffect(() => {
    if (!categories || categories.length === 0) return;
    if (!formData.category_id) return;

    // Find selected category object
    const selected = categories.find(c => c.category_id === formData.category_id);

    if (selected) {
      setTempParentCategorySearchTerm(selected.category_name);
      setTempSearchParentCategory([selected.category_name]);
    }
  }, [categories, formData.category_id]);
// Add this useEffect to detect overlapping configurations when variations change
// Add a useEffect that only validates configurations when we're on the configurations step
useEffect(() => {
  // Only run validation if we're on the configurations step
  if (activeTab2 !== 'sku-configurations') return;
  
  // Revalidate all configurations when variations change while on this step
  if (rows3.length > 0) {
    rows3.forEach(row => {
      validateConfigConflicts(row, rows3);
    });
  }
}, [rows2, activeTab2]); // Run when variations change OR when switching to configurations step
  const renderButton = (key) => {
    console.log("🔘 renderButton called with:", key);
    // Save also stays disabled while a save is running, so it can't be sent twice
    const saveDisabled = currentRowsEmpty || isSaving;
    const disabledStyles = saveDisabled
      ? {
        backgroundColor: '#CED4DA',
        color: '#fff',
        borderColor: 'transparent'
      }
      : {};

    switch (key) {
      case "discard":
        return (
          <>
            <button
              className="dark-button"
              type="button"
              onClick={handleDiscard}
            >
              Discard
            </button>
          </>
        );

      // Update the Back button handler in renderButton function:
case "back":
  return (
    <button
      className="dark-button"
      type="button"
      onClick={() => {
        // Clear configuration errors when going back from Step 3
        if (activeTab2 === "sku-configurations") {
          setRowErrors({});
        }
        
        if (activeTab2 === "sku-variations") setActiveTab2("edit-spu");
        else if (activeTab2 === "sku-configurations") setActiveTab2("sku-variations");
        else if (activeTab2 === "sku-code") setActiveTab2("sku-configurations");
      }}
    >
      Back
    </button>
  );

      case "next":
        return (
          <button
            className={`dark-border ${(spusLoading && activeTab2 === 'edit-spu') ? 'disabled' : ''}`}
            type="button"
            disabled={spusLoading && activeTab2 === 'edit-spu'}
            onClick={() => {
              if (activeTab2 === "edit-spu") {
                handleSaveAndAddToSKU();   // this will automatically call setActiveTab2("sku-variations")
                return;                    // stop here
              }
              else if (activeTab2 === "sku-variations") {
                handleSaveAndConfigureSKU();   // 🔥 SAVE VARIATIONS FIRST + VALIDATE
                return;
              }

              else if (activeTab2 === "sku-configurations") {
                handleSaveConfigurations();
                return;
              }
            }}
          >
            Next
          </button>
        );

  case "save":
  return (
    <button
      className={`dark-button ${saveDisabled ? "disabled" : ""}`}
      type="button"
      disabled={saveDisabled}
      style={disabledStyles}
      onClick={async () => {
        // Make sure we have the latest images in stepData
        const finalData = {
          ...stepData,
          spuImages: uploadedImages, // Ensure we use the current uploadedImages
          skuCodeData: skuCodeRows
        };

        console.log("🔥 FINAL DATA BEFORE SAVE:", finalData);

        saveLocal(finalData);

        // Set isSaving to true to prevent UnsavedChangesPrompt
        // (it also disables this button until the save finishes)
        setIsSaving(true);

        // On success handleFinalSave navigates to the SPU list
        const saved = await handleFinalSave(finalData);

        if (saved) {
          // Clear any draft data
          localStorage.removeItem("spuDraft");
        } else {
          // Nothing was saved: keep the draft and turn Save and the
          // unsaved-changes prompt back on, so the edits aren't lost
          setIsSaving(false);
        }
      }}
    >
      {isSaving ? "Saving..." : "Save"}
    </button>
  );
      default:
        return null;
    }
  };


  useEffect(() => {
    if (!spuData || !spuData.skus) return;

    const mappedRows = spuData.skus.map((sku, index) => {
      const attribute = skuAttributes.find(a =>
        a.id === sku.attributes[0]?.sku_preset_attribute_id
      );

      return {
        id: index + 1,
        fieldName: String(sku.attributes[0]?.sku_preset_attribute_id) || "",
        fieldNameLabel: attribute?.name || "",
        opts: sku.attributes.map(att => {
          const attr = skuAttributes.find(a => a.id === att.sku_preset_attribute_id);
          const option = attr?.options.find(o => o.value === att.sku_preset_option_id);

          return {
            value: String(att.sku_preset_option_id),
            label: option?.label || "",
          };
        }),
        isOpen: false,
        openSkuDropdown: false,
      };
    });

    setRows2(mappedRows);
  }, [spuData, skuAttributes]);

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

const convertSpuImage = async (img) => {
  console.log("Converting image:", img);
  
  // If it's an existing image (has isExisting flag and no file), return null to skip base64 conversion
  if (img.isExisting && !img.file) {
    return null;
  }

  // Handle File object
  if (img.file instanceof File) {
    return await toBase64(img.file);
  }

  // Handle object with file property
  if (img?.file instanceof File) {
    return await toBase64(img.file);
  }

  // Handle blob URL
  if (img?.preview?.startsWith("blob:")) {
    try {
      const response = await fetch(img.preview);
      const blob = await response.blob();
      return await toBase64(blob);
    } catch (error) {
      console.error("Error converting blob to base64:", error);
      return null;
    }
  }

  // Handle direct base64 string
  if (typeof img === "string" && img.startsWith("data:image")) {
    return img;
  }

  // Handle image object with image property
  if (img?.image && typeof img.image === "string") {
    return img.image;
  }

  return null;
};

  const isDuplicateSkuName = (rows, value, currentIndex) => {
    const normalized = value.trim().toLowerCase();

    return rows.some((r, idx) =>
      idx !== currentIndex &&
      r?.name?.trim().toLowerCase() === normalized
    );
  };


const validateSkuCodesSync = (skuRows) => {
  const errors = {};
  let hasError = false;

  const seenNames = {};
  const seenCodes = {};

  skuRows.forEach((row, index) => {
    const rowErrors = {};
    const rowId = row.sku_id || `row-${index}`; // Use unique identifier per row

    const name = row?.name?.trim();
    const code = row?.sku_code?.trim();

    // 🔴 SKU NAME - Only check against previous rows for duplicates
    if (!name) {
      rowErrors.name = "SKU Name is required";
      hasError = true;
    } else {
      // Check if this name exists in ANY OTHER row (not including current)
      const duplicateNameIndex = skuRows.findIndex((r, i) => 
        i !== index && r?.name?.trim().toLowerCase() === name.toLowerCase()
      );
      
      if (duplicateNameIndex !== -1) {
        rowErrors.name = "SKU Name already exists";
        hasError = true;
      } else {
        // Track seen names for future reference
        seenNames[name.toLowerCase()] = true;
      }
    }

    // 🔴 SKU CODE
    if (!code) {
      rowErrors.sku_code = "SKU Code is required";
      hasError = true;
    } else {
      // Check if this code exists in ANY OTHER row (not including current)
      const duplicateCodeIndex = skuRows.findIndex((r, i) => 
        i !== index && r?.sku_code?.trim().toLowerCase() === code.toLowerCase()
      );
      
      if (duplicateCodeIndex !== -1) {
        rowErrors.sku_code = "SKU Code already exists";
        hasError = true;
      } else {
        seenCodes[code.toLowerCase()] = true;
      }
    }

    // 🔴 SIM OPTION (required when product type is Device)
    if (formData.product_type?.toLowerCase() === 'device' && !row.sim_option) {
      rowErrors.sim_option = 'SIM Option is required';
      hasError = true;
    }

    // Only add errors for this specific row if there are any
    if (Object.keys(rowErrors).length > 0) {
      errors[rowId] = rowErrors;
    }
  });

  return { hasError, errors };
};

// Tells the user a save failed; their edits stay on the page.
const showSaveError = (reason) => {
  setAlert({
    type: "error",
    action: "update",
    message: reason
      ? `Couldn't save the SPU: ${reason}`
      : "Couldn't save the SPU. Your changes are still here, so you can try again.",
  });
  setShowItemAlert(true);
};

// Returns true once the SPU is saved (the page then navigates to the list).
const handleFinalSave = async (finalStepData) => {
  // 🔥 FINAL SKU CODE VALIDATION
   const skuRows = Array.isArray(finalStepData.skuCodeData)
    ? finalStepData.skuCodeData
    : Object.values(finalStepData.skuCodeData || {});
    
  const { hasError, errors } = validateSkuCodesSync(skuRows);
  
  if (hasError) {
    // Update only rows with errors, preserving all other errors
    setSkuCodeRows(prev => {
      return prev.map((row, index) => {
        const rowId = row.sku_id || `row-${index}`;
        const rowErr = errors[rowId];
        
        // If this row has errors in this validation, update them
        if (rowErr) {
          return {
            ...row,
            nameError: rowErr.name !== undefined ? rowErr.name : row.nameError,
            skuCodeError: rowErr.sku_code !== undefined ? rowErr.sku_code : row.skuCodeError,
            simOptionError: rowErr.sim_option !== undefined ? rowErr.sim_option : row.simOptionError,
          };
        }

        // For rows without errors in this validation, check if they still have errors
        // based on current values (this ensures we don't clear errors that still exist)
        const nameTrimmed = row.name?.trim() || "";
        const codeTrimmed = row.sku_code?.trim() || "";

        let nameError = "";
        let skuCodeError = "";
        let simOptionError = "";

        if (!nameTrimmed) {
          nameError = "SKU Name is required";
        } else {
          const duplicateNameIndex = prev.findIndex((r, i) =>
            i !== index && r?.name?.trim().toLowerCase() === nameTrimmed.toLowerCase()
          );
          if (duplicateNameIndex !== -1) {
            nameError = "SKU Name already exists";
          }
        }

        if (!codeTrimmed) {
          skuCodeError = "SKU Code is required";
        } else {
          const duplicateCodeIndex = prev.findIndex((r, i) =>
            i !== index && r?.sku_code?.trim().toLowerCase() === codeTrimmed.toLowerCase()
          );
          if (duplicateCodeIndex !== -1) {
            skuCodeError = "SKU Code already exists";
          }
        }

        if (formData.product_type?.toLowerCase() === 'device' && !row.sim_option) {
          simOptionError = "SIM Option is required";
        }

        return {
          ...row,
          nameError: nameError || row.nameError,
          skuCodeError: skuCodeError || row.skuCodeError,
          simOptionError: simOptionError || row.simOptionError,
        };
      });
    });

    setAlert({
      type: "error",
      action: "update",
      message: "Please fix the errors below",
    });

    setShowItemAlert(true);
    return false;
  }

  // Clear all errors only when validation passes completely
  setSkuCodeRows(prev => {
    return prev.map(row => ({
      ...row,
      nameError: "",
      skuCodeError: "",
      simOptionError: "",
    }));
  });

  try {
    // -----------------------------------------------------------
    // 1️⃣ SPU IMAGES - Process all images
    // -----------------------------------------------------------
    const allImages = finalStepData.spuImages || [];
    console.log("Processing images:", allImages);
    
    const spuImageObjects = [];
    const spuImages = [];
    
    // Process each image
    for (let i = 0; i < allImages.length; i++) {
      const img = allImages[i];
      
      if (img.isExisting && img.id) {
        // This is an existing image - just keep the ID reference
        spuImageObjects.push({
          id: img.id,
          order: i + 1
        });
        console.log(`Keeping existing image with ID: ${img.id}`);
      } else {
        // This is a new image - convert to base64
        const base64Image = await convertSpuImage(img);
        if (base64Image) {
          // Wrap base64 string in a dictionary with 'image' key
          spuImages.push({ image: base64Image, user_image_name: img.user_image_name });
          spuImageObjects.push({
            isNew: true,
            order: i + 1
          });
          console.log(`Adding new image at position ${i + 1}`);
        }
      }
    }

    console.log("spuImageObjects:", spuImageObjects);
    console.log("spuImages:", spuImages);

    // -----------------------------------------------------------
    // 2️⃣ SPU CUSTOM FIELDS
    // -----------------------------------------------------------
    const spuCustomFields = (finalStepData.spuData?.customised || []).map(cf => ({
      field_name: cf.field_name || "",
      field_type: cf.field_type || "Text",
      field_data: cf.field_data ?? ""
    }));

    // -----------------------------------------------------------
    // 3️⃣ SKU VARIATIONS
    // -----------------------------------------------------------
    const skuVariations = Array.isArray(finalStepData.skuVariations)
      ? finalStepData.skuVariations.map((v, index) => ({
          attribute_id: v.sku_preset_id,
          order_no: index,
          option_values: (v.sku_preset_option_ids || []).map((opt, idx) => ({
            value: opt,
            order_no: v.sort_numbers?.[idx] ?? idx
          }))
        }))
      : [];

    // -----------------------------------------------------------
    // 4️⃣ SKU CONFIGURATIONS
    // -----------------------------------------------------------
    const cfgData = finalStepData.skuConfigurationsData || {};

    const normalizedConfigs = (cfgData.configurations || []).map(cfg => {
      const option_pairs = (cfg.options || []).map(opt => ({
        sku_preset_id: Number(opt.sku_preset_attribute_id),
        sku_preset_option_id: Number(opt.option_id),
      }));

      return {
        id: cfg.id || Number(cfg.temp_key?.replace("cfg-", "")) || null,
        temp_key: cfg.temp_key,
        configuration_name: cfg.configuration_name,
        option_pairs,
        notes: cfg.notes || "",
      };
    });

    // Process configuration images - also wrap in dictionary
    let finalConfigImages = {};
    const configImageObjects = {};

    for (const [key, images] of Object.entries(cfgData.configurationImages || {})) {
      const newImages = [];
      const existingImageRefs = [];

      for (let i = 0; i < images.length; i++) {
        const img = images[i];

        if (img.isExisting && img.id) {
          existingImageRefs.push({ id: img.id, order: i + 1 });
        } else {
          const base64 = await convertSpuImage(img);
          if (base64) {
            newImages.push({ 
              image: base64, 
              user_image_name: img.user_image_name || '' 
            });
          }
        }
      }

      finalConfigImages[key] = newImages;
      configImageObjects[key] = existingImageRefs;
    }

    const skuConfigurations = {
      configurations: normalizedConfigs,
      configurationImages: finalConfigImages,         
      configurationImageObjects: configImageObjects,
      configurationCustomFields: cfgData.configurationCustomFields || {}
    };

    // -----------------------------------------------------------
    // 5️⃣ SKU CODE DATA
    // -----------------------------------------------------------
    const skuCodeData = Array.isArray(finalStepData.skuCodeData)
      ? finalStepData.skuCodeData
      : Object.values(finalStepData.skuCodeData || {});

    // -----------------------------------------------------------
    // 6️⃣ FINAL PAYLOAD
    // -----------------------------------------------------------
    const finalPayload = {
      spuData: {
        ...finalStepData.spuData,
        images: undefined,
        release_date: finalStepData.spuData?.release_date || null
      },
      spuImageObjects,
      spuImages,
      spuCustomFields,
      skuVariations,
      skuConfigurations,
      skuCodeData
    };
    
    console.log('Final payload:', JSON.stringify(finalPayload, null, 2));

    // -----------------------------------------------------------
    // 7️⃣ API CALL
    // -----------------------------------------------------------
    const spuId = finalStepData?.spuData?.spu_id || id;

    const response = await apiHelper(
      `inventory/spu-sku/full/${spuId}/update/`,
      "PUT",
      finalPayload,
      "application/json"
    );

    if (!response.ok) {
      // A Django 500 is an HTML page, so the body may not be JSON
      const err = await response.json().catch(() => null);
      console.error("🚨 Update failed:", err);
      showSaveError(firstErrorMessage(err));
      return false;
    }

    invalidateSpuNamesCache(); // ensure next Add/Edit SPU sees the updated record
    history.push("/spu-sku", {
      alert: { type: "success", action: "update", recordName: "SPU & SKU" }
    });
    return true;

  } catch (error) {
    console.error("❌ Unexpected Final Save Error:", error);
    showSaveError();
    return false;
  }
};



  const handleConfigNoteChange = (configKey, value) => {
    setRows3(prev =>
      prev.map(row =>
        (row.temp_key || row.uniqueKey) === configKey
          ? { ...row, notes: value }
          : row
      )
    );
  };


  useEffect(() => {
    if (!rows2.length || !skuAttributeOptions.length) return;

    console.log("♻️ Regenerating SKUs...");

    setSkuCodeRows(prev =>
      generateCombinationsFromVariations(
        rows2,
        skuAttributeOptions,
        prev          // 🔥 USE LATEST EDITED DATA
      )
    );
  }, [rows2, skuAttributeOptions]);


  useEffect(() => {
    originalSkuRowsRef.current = skuCodeRows;
  }, [skuCodeRows]);
// Add this useEffect to sync configuration options when rows2 changes
useEffect(() => {
  // Function to filter out invalid options from configurations
  const filterInvalidOptions = () => {
    if (!rows2.length || !rows3.length) return;
    
    // Create a map of valid options by preset_id
    const validOptionsByPreset = {};
    rows2.forEach(row => {
      if (row.fieldName && row.opts?.length) {
        const presetId = String(row.fieldName);
        validOptionsByPreset[presetId] = new Set(
          row.opts.map(opt => String(opt.value))
        );
      }
    });
    
    // Check if any configuration has invalid options
    const hasInvalidOptions = rows3.some(row => {
      return row.opts?.some(opt => {
        const presetId = String(opt.preset_id || opt.sku_preset_attribute_id);
        const optionId = String(opt.option_id);
        return !validOptionsByPreset[presetId]?.has(optionId);
      });
    });
    
    if (hasInvalidOptions) {
      // Update rows3 to remove invalid options
      const updatedRows3 = rows3.map(row => {
        if (!row.opts?.length) return row;
        
        const filteredOpts = row.opts.filter(opt => {
          const presetId = String(opt.preset_id || opt.sku_preset_attribute_id);
          const optionId = String(opt.option_id);
          return validOptionsByPreset[presetId]?.has(optionId);
        });
        
        return {
          ...row,
          opts: filteredOpts
        };
      });
      
      setRows3(updatedRows3);
      
      // Update stepData.skuConfigurationsData if it exists
      if (stepData.skuConfigurationsData?.configurations) {
        setStepData(prev => ({
          ...prev,
          skuConfigurationsData: {
            ...prev.skuConfigurationsData,
            configurations: prev.skuConfigurationsData.configurations.map(config => {
              const row = updatedRows3.find(r => 
                r.configuration_id === config.id || 
                r.temp_key === config.temp_key ||
                r.uniqueKey === config.temp_key
              );
              
              if (row) {
                return {
                  ...config,
                  options: row.opts.map(opt => ({
                    sku_preset_attribute_id: Number(opt.sku_preset_attribute_id),
                    option_id: Number(opt.option_id)
                  }))
                };
              }
              return config;
            })
          }
        }));
      }
    }
  };
  
  filterInvalidOptions();
}, [rows2]); // Run when rows2 changes
  // Add useEffect to validate configurations when rows2 changes
  // useEffect(() => {
  //   // When variations change, re-validate all configurations
  //   if (rows2.length > 0 && rows3.length > 0) {
  //     rows3.forEach(row => {
  //       const completenessError = validateConfigurationOptionsCompleteness(row, rows2, skuAttributes);
  //       if (completenessError && row.opts && row.opts.length > 0) {
  //         // Only show error if there are options but not covering all variations
  //         setRowErrors(prev => ({
  //           ...prev,
  //           [row.id]: {
  //             ...prev[row.id],
  //             configuration_options: completenessError
  //           }
  //         }));
  //       }
  //     });
  //   }
  // }, [rows2]);

  const checkDuplicate = (brand) => {
    let hasDuplicates = false;
    const newErrors = { ...errors };
    if (formData.model_name?.trim() && brand.brand_id) {
        const normalized = formData.model_name.trim().toLowerCase();
        const exists = allSpus.some(
            (m) => m.model_name && m.model_name.trim().toLowerCase() === normalized && brand.brand_id == m.brand_id && m.spu_id != Number(id) && formData.category_id == m.category_id && formData.product_type == m.product_type
        );
        if (exists) {
            newErrors.model_name = "SPU Name already exists";
            hasDuplicates = true;
        }else {
          newErrors.model_name = "";
        }
    }
    // if (hasDuplicates) {
        setFormErrors(newErrors);
    // }

};

  return (
    <>
      <div className="company-body main-company-body-inner new-look" style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}>
        <div className="breadcrumb">
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return (
              <span
                key={index}
                className={`breadcrumb-item ${crumb === "SPU & SKU" ? "clickable" : ""}`}
                onClick={() => {
                  if (crumb === "SPU & SKU") {
                    history.push("/spu-sku");
                  }
                }}
                style={{ cursor: crumb === "SPU & SKU" ? "pointer" : "default" }}
              >
                {crumb}
                {!isLast ? "  " : ""}
              </span>
            );
          })}
        </div>
        {showItemAlert && alert && (
          <AlertNotification
            type={alert.type}
            action={alert.action}
            recordName={alert.recordName}
            message={alert.message}
            onClose={() => setShowItemAlert(false)}
          />
        )}
        <div className="progress-stepper-container mb-4">
          <SpuProgressStepper currentStep={stepMapping[activeTab2]} />
        </div>
        <div className='edit-organisation-info'>
          <div className='edit-organisation-left'>
            <h1>{currentTab.heading}</h1>
          </div>
          <div className="discard-save-organisation-right d-flex align-items-center justify-content-end flex-wrap gap-2">
            {tabContent[activeTab2]?.buttons.map((btnKey, idx) => (
              <React.Fragment key={idx}>
                {renderButton(btnKey)}
              </React.Fragment>
            ))}
          </div>

        </div>
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            paddingBottom: '24px',
          }}
        >
          <div className="employee-tabs-container">

            {successMessage && <div style={{ color: 'green' }} className="success-message">{successMessage}</div>}
            <ul style={{ color: 'red' }}>
              {validationError && validationError.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>

            {activeTab2 === 'edit-spu' && (
              <div className="tab-content" id="edit-spu-content">
                <div className="info-section">
                  {/* ─── SPU INFO CARD ─────────────────────────────────────────── */}
                  <div className="info-card new-info-overflow-auto">
                    <div className="info-header">
                      <h4 className="info-title">Basic Info</h4>
                    </div>
                    <div className="info-content d-block">
                      <div className='grid-info-adding'>

                        {/* ─── ROW 1: SPU NAME & STATUS ───────────────────────────────── */}
                        <div className='row gappingcls-added'>
                          <div className='col-lg-6 col-md-6 col-12'>
                            <div className="info-inner">
                              <label
                                htmlFor="spuName"
                                className="form-label d-flex align-items-center gap-1"
                              >
                                SPU Name <span className='error-color'>*</span>
                              </label>

                              <input
                                type="text"
                                className={`form-control common-input-all  ${errors.model_name ? 'err-color' : ''}`}
                                id="spuName"
                                name="model_name"
                                value={formData.model_name}
                                onBlur={(e) =>
                                  validateOnBlur("model_name", e.target.value, "SPU Name")
                                }
                                onChange={handleChangeWithDirty}
                              />
                              {errors.model_name && (
                                <div className="invalid-feedback d-block">
                                  {errors.model_name}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className='col-lg-6 col-md-6 col-12'>
                            <div className="info-inner">
                              <label htmlFor="status" className="form-label">
                                Status <span className='error-color'>*</span>
                              </label>
                              <div className='flexing-type-radio'>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    id="flexRadioDefault1"
                                    name="status"
                                    value="1"
                                    checked={formData.status === 1}
                                    onChange={handleChangeWithDirty}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                    style={{ fontWeight: 'normal', fontSize: '14px' }}
                                  >
                                    Active
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="status"
                                    value="0"
                                    checked={formData.status === 0}
                                    onChange={handleChangeWithDirty}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault2"
                                    style={{ fontWeight: 'normal', fontSize: '14px' }}
                                  >
                                    Inactive
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ─── ROW 2: ID & Model Prefix  ─────────────────────────────────────── */}
                        <div className='row gappingcls-added'>
                          <div className='col-lg-6 col-md-6 col-12'>
                            <div className="info-inner">
                              <label
                                htmlFor="modelPrefix"
                                className="form-label d-flex align-items-center gap-1"
                              >
                                Prefix
                                <Tooltip title="Prefix" body="A short code for the SPU, used in automating SKU Code generation">
                                  <Info size={16} className="info-icon" />
                                </Tooltip>
                              </label>
                              <input
                                type="text"
                                className={`form-control common-input-all`}
                                id="modelPrefix"
                                // placeholder="Model Prefix"
                                name="prefix"
                                value={formData.prefix} onChange={handleChangeWithDirty}
                              />
                            </div>
                          </div>
                          <div className='col-lg-6 col-md-6 col-12'>
                            <div className="info-inner">
                              <label
                                htmlFor="spuId"
                                className="form-label d-flex align-items-center gap-2"
                              >
                                ID
                              </label>
                              <input
                                type="text"
                                className={`form-control common-input-all ${errors.model_id ? "err-color" : ""
                                  }`}
                                id="spuId"
                                // placeholder="SPU ID"
                                name="model_id"
                                value={formData.model_id} onChange={handleChangeWithDirty}
                                onBlur={(e) => {
                                  const value = e.target.value;

                                  // Required (if ID is mandatory)
                                  if (!validateOnBlur("model_id", value, "ID")) return;

                                  // Duplicate check
                                  if (
                                    isDuplicate({
                                      list: allSpus,
                                      field: "model_id",
                                      value,
                                      excludeId: Number(id),
                                    })
                                  ) {
                                    setFormErrors(prev => ({
                                      ...prev,
                                      model_id: "ID already exists"
                                    }));
                                  } else {
                                    setFormErrors(prev => ({
                                      ...prev,
                                      model_id: ""
                                    }));
                                  }
                                }}
                              />
                              {errors.model_id && (
                                <div className="invalid-feedback d-block">
                                  {errors.model_id}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                      </div> {/* end of grid-info-adding */}
                    </div> {/* end of info-content */}
                  </div> {/* end of info-card */}

                  {/* ─── Product INFO CARD ─────────────────────────────────────────── */}
                  <div className="info-card new-info-overflow-auto">
                    <div className="info-header">
                      <h4 className="info-title">Product Info</h4>
                    </div>
                    <div className="info-content d-block">
                      <div className='grid-info-adding'>
                        {/* ─── ROW 1: Brand & Category  ────────────── */}
                        <div className='row gappingcls-added'>

                          <div className='col-lg-6 col-md-6 col-12'>
                            <MultiSelectSearch
                              label="Brand"
                              tooltip={<span className='error-color'>*</span>}
                              options={brands}                         // your brands
                              selected={
                                formData.brand_id
                                  ? [brands.find(b => b.brand_id === formData.brand_id)]
                                  : []
                              }
                              setSelected={(sel) => {
                                const brand = sel[0] || null;
                                setFormData(prev => ({ ...prev, brand_id: brand ? brand.brand_id : "" }));
                                setFormErrors(prev => ({ ...prev, brand_id: "" }));
                                validateOnBlur(
                                  "brand_id",
                                  brand ? brand.brand_id : "",
                                  "Brand"
                                );
                              }}
                              idKey="brand_id"
                              displayKey="brand_name"
                              logoKey="original_logo_url"
                              multiple={false}                          // SINGLE SELECT
                              keysToSearch={["brand_name"]}
                              fallbackImage={noImage}
                              error={!!errors.brand_id}
                              subTitleFn={(item) => {
                                  const h = item.brand_hierarchy || [];
                                  return h.length >= 1 ? h.map(b => b.name).join(' >> ') : null;
                              }}
                              triggerValidation={(item) => {
                                  checkDuplicate(item);
                              }}
                            />
                            {errors.brand_id && (
                              <div className="invalid-feedback d-block">{errors.brand_id}</div>
                            )}
                          </div>
                          <div className='col-lg-6 col-md-6 col-12'>
                            <div className="info-inner">
                              <label className="form-label d-flex align-items-center gap-1">
                                Category <span className='error-color'>*</span>
                              </label>

                              <div style={{ position: "relative" }} ref={categoryRef}>
                                {/* Input Box */}
                                <div
                                  className="form-control common-input-all d-flex items-center cursor-pointer rounded p-2"
                                  style={{
                                    justifyContent: "space-between",
                                    height: "40px",
                                    border: errors.category_id ? "1px solid #dc3545" : "1px solid #6C757D"
                                  }}
                                >
                                  <input
                                    type="text"
                                    value={tempParentCategorySearchTerm || ""}
                                    onFocus={() => setIsCategoryOpen(true)}
                                    onClick={() => setIsCategoryOpen(true)}
                                    onChange={(e) => {
                                        setJustOpened(false);
                                        setTempParentCategorySearchTerm(e.target.value || "");
                                      }}
                                    style={{
                                      flex: 1,
                                      border: "none",
                                      outline: "none",
                                      background: "transparent",
                                      fontSize: "14px"
                                    }}
                                  />

                                  {/* CLEAR ICON — FIXED */}
                                  {tempParentCategorySearchTerm && (
                                    <span
                                      onClick={() => {
                                        setTempParentCategorySearchTerm("");
                                        setFormData(prev => ({ ...prev, category_id: "" }));
                                        validateOnBlur("category_id", "", "Category");
                                        setFormErrors(prev => ({ ...prev, model_name: "" }));
                                      }}
                                      style={{
                                        marginRight: "6px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                        color: "#6C757D",
                                        paddingTop:"2px"
                                      }}
                                    >
                                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path
                                          d="M9 3L3 9M3 3L9 9"
                                          stroke="#212529"
                                          strokeWidth="1.3"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </span>
                                  )}

                                  {/* CHEVRON ICON — FIXED */}
                                  <span
                                    onClick={() => setIsCategoryOpen(prev => !prev)}
                                    style={{ cursor: "pointer", display: "flex",paddingTop:"3px"}}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      style={{
                                        transform: isCategoryOpen ? "rotate(0deg)" : "rotate(180deg)",
                                        transition: "0.2s",
                                      }}
                                    >
                                      <path
                                        d="M4.5 11.25L9 6.75L13.5 11.25"
                                        stroke="#212529"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </span>
                                </div>

                                {/* DROPDOWN */}
                                {isCategoryOpen && (
                                  <div
                                    className="bg-white border rounded shadow-lg mt-1"
                                    style={{
                                      maxHeight: "270px",
                                      overflowY: "auto",
                                      position: "absolute",
                                      left: 0,
                                      right: 0,
                                      zIndex: 1000
                                    }}
                                  >
                                    <div
                                      className="filter-options"
                                      style={{
                                        border: "1px solid #e9ecef",
                                        borderRadius: "8px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        backgroundColor: "#fff",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                                      }}
                                    >
                                      {categoryHierarchy
                                        // .filter((item) => {
                                        //   const search = (tempParentCategorySearchTerm || "").toLowerCase();
                                        //   const fullText =
                                        //     ((item.name || "") + " " + getHierarchyString(item)).toLowerCase();
                                        //   return fullText.includes(search);
                                        // })
                                        .filter((item) => {
                                          if (justOpened) return true;   // 🔥 show ALL options on first open

                                          const search = (tempParentCategorySearchTerm || "").toLowerCase();
                                          const fullText =
                                            ((item.name || "") + " " + getHierarchyString(item)).toLowerCase();
                                          return fullText.includes(search);
                                        })
                                        // .slice(0, 10)
                                        .map((item, index) => {
                                          const hierarchy = getHierarchyString(item);
                                          const isSelected = tempSearchParentCategory.includes(item.name);

                                          return (
                                            <div
                                              key={index}
                                              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#FFFDE7'}
                                              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                              style={{
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                                backgroundColor: "transparent",
                                                borderRadius: 4,
                                              }}
                                              onClick={() => {
                                                setTempParentCategorySearchTerm(item.name);
                                                setTempSearchParentCategory([item.name]);
                                                setFormData(prev => ({ ...prev, category_id: item.id }));
                                                setIsCategoryOpen(false);
                                                setJustOpened(false);
                                                validateOnBlur("category_id", item.id, "Category");
                                                if (formData.model_name?.trim() && formData.brand_id) {
                                                  const normalized = formData.model_name.trim().toLowerCase();
                                                  const exists = allSpus.some(
                                                    (m) => m.model_name && m.model_name.trim().toLowerCase() === normalized && formData.brand_id == m.brand_id && m.spu_id != Number(id) && item.id == m.category_id && formData.product_type == m.product_type
                                                  );
                                                  setFormErrors(prev => ({ ...prev, model_name: exists ? "SPU Name already exists" : "" }));
                                                }
                                              }}
                                            >
                                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span style={{ fontFamily: 'Montserrat', fontSize: '14px', fontStyle: 'normal', fontWeight: 400, lineHeight: '18px', color: '#212529' }}>{item.name}</span>
                                                {hierarchy && (
                                                  <span style={{ fontFamily: 'Montserrat', fontSize: '12px', color: '#6C757D', fontWeight: 400, fontStyle: 'normal' }}>
                                                    {hierarchy}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        })}

                                      {categoryHierarchy.length === 0 && (
                                        <div
                                          style={{
                                            padding: "12px",
                                            textAlign: "center",
                                            color: "#6C757D",
                                            fontSize: "14px"
                                          }}
                                        >
                                          No categories found
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {errors.category_id && (
                                  <div className="invalid-feedback d-block">{errors.category_id}</div>
                                )}
                              </div>
                            </div>

                          </div>


                        </div>
                        {/* ─── ROW 2: Type & Release Date  ────────────── */}
                        <div className='row gappingcls-added'>

                          <div className='col-lg-6 col-md-6 col-12'>
                            <div className="info-inner">
                              <label
                                htmlFor="type"
                                className="form-label d-flex align-items-center gap-1"
                              >
                                Type <span className="error-color">*</span>
                              </label>

                              <div style={{ position: "relative" }} ref={osTypeRef}>
                                {/* INPUT BOX */}
                                <div
                                  className={`form-control common-input-all d-flex items-center cursor-pointer rounded p-2 ${errors.product_type ? 'err-color' : ''}`}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    height: '40px',
                                    alignItems: 'center'
                                  }}
                                >
                                  <input
                                    type="text"
                                    value={osTypeSearch}
                                    onFocus={() => setIsOsTypeOpen(true)}
                                    onClick={() => setIsOsTypeOpen(true)}
                                    onChange={(e) => {setOsTypeSearch(e.target.value); setJustOpenedType(false);}}
                                    // placeholder="Select Type"
                                    style={{
                                      flex: 1,
                                      border: "none",
                                      outline: "none",
                                      background: "transparent",
                                      fontSize: "14px"
                                    }}
                                  />

                                  {/* CLEAR ICON */}
                                  {osTypeSearch && (
                                    <span
                                      onClick={() => {
                                        setOsTypeSearch("");
                                        handleOsTypeSelect("");
                                        validateOnBlur("product_type", "", "Type");
                                        setFormErrors(prev => ({ ...prev, model_name: "" }));
                                      }}
                                      style={{
                                        marginRight: "6px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                        color: "#6C757D"
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                      >
                                        <path
                                          d="M9 3L3 9M3 3L9 9"
                                          stroke="#212529"
                                          strokeWidth="1.33333"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </span>
                                  )}
                                  <span
                                    onClick={() => setIsOsTypeOpen(prev => !prev)}
                                    style={{ cursor: "pointer", display: "flex" }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      style={{
                                        transform: isOsTypeOpen ? "rotate(0deg)" : "rotate(180deg)",
                                        transition: "0.2s",
                                      }}
                                    >
                                      <path
                                        d="M4.5 11.25L9 6.75L13.5 11.25"
                                        stroke="#212529"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </span>
                                </div>

                                {/* DROPDOWN */}
                                {isOsTypeOpen && (
                                  <div
                                    className="bg-white border rounded shadow-lg mt-1"
                                    style={{
                                      maxHeight: "270px",
                                      overflowY: "auto",
                                      position: "absolute",
                                      left: 0,
                                      right: 0,
                                      zIndex: 1000,
                                    }}
                                  >
                                    <div
                                      className="filter-options"
                                      style={{
                                        marginTop: "8px",
                                        border: "1px solid #e9ecef",
                                        borderRadius: "8px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        backgroundColor: "#fff",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                        position: "relative",
                                      }}
                                    >
                                      {
                                      // filteredOsTypes.length > 0 ? (
                                      //   filteredOsTypes.map((item, index) => (
                                      //     <div
                                      //       key={index}
                                      //       style={{
                                      //         padding: "8px 12px",
                                      //         cursor: "pointer",
                                      //         fontSize: "14px",
                                      //       }}
                                      //       className="hover:bg-gray-100"
                                      //       onClick={() => {
                                      //         handleOsTypeSelect(item?.product_type);
                                      //         setOsTypeSearch(item?.product_type);
                                      //         setIsOsTypeOpen(false);
                                      //         setJustOpenedType(false);
                                      //         validateOnBlur("product_type", item?.product_type, "Type");
                                      //       }}
                                      //     >
                                      //       {item?.product_type}
                                      //     </div>
                                      //   ))
                                      // )
                                      filteredOsTypes.length > 0 ? (
                                        filteredOsTypes.map((item, index) => {
                                          const isSelected = formData.product_type === item?.product_type;

                                          return (
                                            <div
                                              key={index}
                                              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#FFFDE7'}
                                              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                              className="hover:bg-gray-100"
                                              style={{
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                                backgroundColor: isSelected ? "#FFFDE7" : "transparent",
                                                transition: "background-color 0.2s ease"
                                              }}
                                              onClick={() => {
                                                handleOsTypeSelect(item?.product_type);
                                                setIsOsTypeOpen(false);
                                                setJustOpenedType(false);
                                                validateOnBlur("product_type", item?.product_type, "Type");
                                                if (formData.model_name?.trim() && formData.brand_id) {
                                                  const normalized = formData.model_name.trim().toLowerCase();
                                                  const exists = allSpus.some(
                                                    (m) => m.model_name && m.model_name.trim().toLowerCase() === normalized && formData.brand_id == m.brand_id && m.spu_id != Number(id) && formData.category_id == m.category_id && item?.product_type == m.product_type
                                                  );
                                                  setFormErrors(prev => ({ ...prev, model_name: exists ? "SPU Name already exists" : "" }));
                                                }
                                              }}
                                            >
                                              {item?.product_type}
                                            </div>
                                          );
                                        })
                                      )
 
                                      : (
                                        <div
                                          style={{
                                            padding: "12px",
                                            textAlign: "center",
                                            color: "#6C757D",
                                            fontSize: "14px"
                                          }}
                                        >
                                          No types found
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}

                                {errors.product_type && (
                                  <div className="invalid-feedback d-block">
                                    {errors.product_type}
                                  </div>
                                )}
                              </div>
                            </div>


                          </div>
                          <div className='col-lg-6 col-md-6 col-12'>
                            <CalendarInput
                              label="Release Date"
                              name="release_date"
                              value={formData.release_date}
                              onChange={handleChangeWithDirty}
                              onBlur={handleFieldBlur}
                              required
                              error={errors.release_date}
                            />
                            {errors.release_date && (
                              <div className="invalid-feedback d-block">
                                {errors.release_date}
                              </div>
                            )}
                          </div>

                        </div>
                        {/* ─── ROW 3: Images  ────────────── */}
                        <div className="row gappingcls-added">
                          <div className="col-12">
                            <div className="info-inner">
                              <label className="form-label d-flex align-items-center gap-2">
                                Images
                              </label>

                              {/* Dropzone */}
                              <div
                                className="upload-container"
                                onClick={handleBrowseClick}
                                onDragOver={e => e.preventDefault()}
                                onDragEnter={() => setIsDragging(true)}
                                onDragLeave={() => setIsDragging(false)}
                                onDrop={handleDrop}
                                style={{
                                  border: `1px dashed ${uploadError
                                      ? '#DC3545'            // ❌ Error (red)
                                      : isDragging
                                        ? '#0D6EFD'            // 🔵 Dragging
                                        : '#ccc'               // ⚪ Default
                                    }`,
                                  borderRadius: 4,
                                  padding: '3rem 1.5rem',
                                  textAlign: 'center',
                                  cursor: 'pointer',
                                  backgroundColor: isDragging ? '#CFE2FF' : '#fff', // Drag highlight
                                  transition: 'background-color 0.3s ease',
                                }}
                              >
                                <CloudUpload size={32} />
                                <p style={{ margin: 0, color: '#555', fontSize: '0.9rem' }}>
                                  Drag your image here or{' '}
                                  <span style={{ color: '#007bff', textDecoration: 'underline' }}>
                                    Browse
                                  </span>
                                </p>
                                <input
                                  type="file"
                                  accept="image/png, image/jpeg"
                                  multiple
                                  ref={fileInputRef}
                                  style={{ display: 'none' }}
                                  onChange={handleImageChange}
                                />
                              </div>

                              {/* Uploaded Images */}
                              {uploadedImages.length > 0 && (
                                <div className="uploaded-images mt-3">
                                  <p className='mb-3'>
                                    {uploadedImages.length} Image
                                    {uploadedImages.length > 1 ? 's' : ''} uploaded
                                  </p>

                                  <ReactSortable
                                    list={uploadedImages}
                                    setList={setUploadedImages}
                                    handle=".drag-handle"
                                    tag="div"
                                    className="row g-2"
                                    chosenClass="is-dragging"    // ← this class goes on the dragged item
                                  >
{uploadedImages.map(img => (
  <div className="col-md-4 col-sm-6" key={img.id}>
    <div className="d-flex align-items-center justify-content-between p-2 border rounded" style={{ boxShadow: '0px 1px 4px 0px #0000001A' }}>
      <div className="d-flex align-items-center gap-2">
        <X size={18} onClick={() => handleRemove(img.id)} className="cursor-pointer" style={{ flex: 'none' }} />
        <img
          src={img.preview || img.spu_image_name}
          alt={img.displayName || "Image preview"}
          onError={(e) => {
            console.log("Image failed to load:", img.spu_image_name);
            e.target.src = noImage;
          }}
          style={{
            width: 40,
            height: 40,
            objectFit: 'cover',
            borderRadius: 4,
          }}
        />
        <div>
          <div style={{ 
            fontSize: '0.85rem', 
            fontWeight: 500, 
            whiteSpace: 'nowrap', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            maxWidth: '150px', 
            color: '#6C757D' 
          }}>
            {img.displayName || (img.user_image_name ? img.user_image_name : 'Image')}
          </div>
          <div style={{ fontSize: '0.75rem', color: '#6C757D' }}>
            {img.file ? formatSize(img.file.size) : ''}
          </div>
        </div>
      </div>
      <Menu
        size={16}
        className="drag-handle text-muted"
        style={{ cursor: 'grab', flex: 'none' }}
      />
    </div>
  </div>
))}
                                  </ReactSortable>
                                </div>
                              )}
                              {uploadError && (
                                <div className="invalid-feedback d-block">
                                  {uploadError}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <UnsavedChangesPrompt isDirty={isDirty} /> */}
                    </div>
                  </div>

                  {/* ─── Customised Info CARD ─────────────────────────────────────────── */}
                  <div className="info-card new-info-overflow-auto main-company-body-inner">
                    <div className="info-header"><h4 className="info-title">Customised Info</h4></div>
                    <div className="info-content d-block entities-tab">
                      <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                        {(rows.length > 0) && (
                          <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                            <table className="entities-table">
                              <thead>
                                <tr>
                                  <th />
                                  <th>
                                    Field Name <span style={{ color: "red" }}>*</span>
                                  </th>
                                  <th>
                                    Field Type <span style={{ color: "red" }}>*</span>
                                  </th>
                                  <th>
                                    Field Value <span style={{ color: "red" }}>*</span>
                                  </th>
                                  <th />
                                </tr>
                              </thead>


                              <ReactSortable list={rows} setList={setRows} handle=".drag-handle" tag="tbody">
                                {rows.map((r, idx) => {
                                  if (!rowRefs.current[r.id]) rowRefs.current[r.id] = React.createRef();
                                  const ref = rowRefs.current[r.id];
                                  return <EntityRow key={r.id} refNode={ref} rowState={r} index={idx}
                                    deleteRow={deleteSpuRow} updateRowBulk={updateRowBulk} rowErrors={rowErrors[r.id] || {}}
                                    validateRowField={validateRowField} rows={rows} />;
                                })}
                              </ReactSortable>
                            </table>
                          </div>
                        )}
                        <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                          <button onClick={addRow} className="dark-button">Add Fields</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ─── ADDITIONAL INFO CARD ─────────────────────────────────────────── */}
                  <div className="info-card">
                    <div className="info-header">
                      <h4 className="info-title">Notes</h4>
                    </div>
                    <div className="info-content">
                      <div className="info-inner common-textarea">
                        {/* <label
                          htmlFor="exampleFormControlTextarea1"
                          className="form-label"
                        >
                          Note
                        </label> */}
                        <textarea
                          className="form-control w-100 common-textarea-all"
                          id="exampleFormControlTextarea1"
                          rows="3"
                          name="notes"
                          value={formData.notes}
                          onChange={handleChangeWithDirty}
                        ></textarea>

                      </div>
                    </div>
                  </div>
                </div> {/* end of info-section */}
              </div>
            )}
            {activeTab2 === 'sku-variations' && (
              <div className="tab-content" id="sku-variations-content">
                <div className="info-section">
                  <div className="info-card new-info-overflow-auto main-company-body-inner">
                    <div className="info-content d-block entities-tab">
                      <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                        <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                          <table className="entities-table tab-table w-100">
                            <thead height="45px">
                              <tr>
                                <th />
                                <th style={{ width: '30%' }}>
                                  SKU Variation <span style={{ color: "red" }}>*</span>
                                </th>
                                <th style={{ width: '100%' }}>
                                  Variation Options <span style={{ color: "red" }}>*</span>
                                </th>


                                <th /></tr>
                            </thead>
                            <ReactSortable list={rows2} setList={setRows2} handle=".drag-handle" tag="tbody">
                              {rows2.map((r, idx) => {
                                if (!rowRefs2.current[r.id]) rowRefs2.current[r.id] = React.createRef();
                                return (
                                  <VariationRow
                                    key={r.id}
                                    refNode={rowRefs2.current[r.id]}
                                    rowState={r}
                                    index={idx}
                                    deleteRow={deleteRow2}
                                    updateRow={updateRow2}
                                    skuAttributes={skuAttributes}
                                    skuAttributeOptions={skuAttributeOptions}
                                    rows2={rows2} // Pass rows2 to track selected attributes and options
                                  />
                                );
                              })}
                            </ReactSortable>
                          </table>
                        </div>
                        <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                          <button style={{padding:'10px'}} onClick={addRow2} className="dark-button">Add Variation</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {archivedModalOpen && (
              <>
                {/* Overlay */}
                <div className="drawer-overlay" />

                <div
                  className="entity-drawer modal-popup-cls"
                  ref={archivedRef}
                  style={{
                    maxWidth: 650,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                    overflow: "inherit",
                  }}
                >
                  <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button className="close-btn" onClick={() => setArchivedModalOpen(false)}>
                      <X size={20} />
                    </button>
                  </div>

                  <h3 style={{
                    textAlign: "left", color: "#212529", fontSize: "20px",
                    fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat",
                    marginBottom: "5px"
                  }}>The SPU can't be archived</h3>

                  <p style={{
                    marginBottom: "0", textAlign: "left", color: "#6C757D",
                    fontSize: "14px", fontWeight: "400", lineHeight: "20px",
                    fontFamily: "Montserrat"
                  }}>
                    This SPU can't be archived because it's referenced by one or more SPUs.
                    Please remove or reassign those SPUs before archiving.
                  </p>

                  <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                    <button className="btn-save" onClick={handleArchivedConfirm}>
                      OK
                    </button>
                  </div>
                </div>
              </>
            )}

            {activeTab2 === 'sku-configurations' && (
              <div className="tab-content" id="sku-configurations-content">
                <div className="info-section">
                  {/* ─── SKU Configurations CARD ─────────────────────────────────────────── */}
                  <div className="info-card new-info-overflow-auto main-company-body-inner">
                    <div className="info-content d-block entities-tab">
                      <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>

                        {/* EMPTY STATE */}
                        {rows3.length === 0 ? (
                          <div className="edit-organisation-info" style={{ paddingBottom: "0px", boxShadow: 'none' }}  >
                            <button onClick={addRow3} className="dark-button" style={{ display: 'flex', height: '34px', minWidth: '100px', justifyContent: 'center', alignItems: 'center', gap: '10px', borderRadius: '8px', fontSize: '12px', fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '600', lineHeight: 'normal', border: '1px solid #212529', padding:'10px' }} disabled={isAddConfigDisabled}>Add Configuration</button>
                          </div>
                        ) : (
                          <>
                            {/* TABLE */}
                            <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                              <table className="entities-table tab-table w-100">
                                <thead height="35px">
                                  <tr>
                                    <th />
                                    <th style={{maxWidth: "150px"}}>Configuration Name <span style={{ color: "#DC3545" }}>*</span></th>
                                    <th style={{maxWidth:"400px"}}>Configuration Options <span style={{ color: "#DC3545" }}>*</span></th>
                                    <th />
                                  </tr>
                                </thead>

                                <ReactSortable
                                  list={rows3}
                                  setList={setRows3}
                                  handle=".drag-handle"
                                  tag="tbody"
                                >
                                  {rows3.map((r, idx) => (
                                    <ConfigRow
                                      key={r.id}
                                      rowState={r}
                                      index={idx}
                                      deleteRow={deleteRow3}
                                      updateRow={updateRow3}
                                      rows2={rows2}
                                      skuAttributes={skuAttributes}
                                      skuAttributeOptions={skuAttributeOptions}
                                      validateRowField={validateRowField}              // ✅ PASS
                                      validateConfigConflicts={validateConfigConflicts} // ✅ PASS
                                      rowErrors={rowErrors}
                                      validateConfigurationOptionsCompleteness={validateConfigurationOptionsCompleteness}
                                      setRowErrors={setRowErrors}
                                      rows3={rows3}
                                    />
                                  ))}
                                </ReactSortable>
                              </table>
                            </div>

                            {/* ADD BUTTON BELOW TABLE */}
                            <div className="edit-organisation-info" style={{ paddingBottom: "0px", boxShadow: 'none' }} >
                              <button onClick={addRow3} className="dark-button" style={{ display: 'flex', height: '34px', minWidth: '100px', padding: '10px', justifyContent: 'center', alignItems: 'center', gap: '10px', borderRadius: '8px', fontSize: '12px', fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '600', lineHeight: 'normal', border: '1px solid #212529', }} disabled={isAddConfigDisabled}>Add Configuration</button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {rows3.length > 0 && (
                    <div className="info-card new-info-overflow-auto main-company-body-inner">
                      <div className="info-content d-block entities-tab">
                        <div className="pt-container">
                          <div className="tabs-wrapper">
                            <div className="tabs" ref={containerRef}>
                              {productTabs
                                .filter(t => !overflowTabs.includes(t.key))
                                .map(tab => (
                                  <button
                                    key={tab.key}
                                    ref={el => el && (tabRefs.current[tab.key] = el)}
                                    className={`tab ${activeTab === tab.key ? "active" : ""}`}
                                    onClick={() => {
                                      setActiveTab(tab.key);
                                      setMenuOpen(false);
                                    }}
                                  >
                                    {tab.label}
                                  </button>
                                ))}
                            </div>

                            <button
                              ref={triggerRef}
                              className={`tab-trigger ${menuOpen ? "active" : ""}`}
                              onClick={toggleMenu}
                            >
                              <ChevronDown className="h-5 w-5" />
                            </button>
                          </div>

                          {/* portal menu */}
                          {portalMenu}

                          {/* your tab contents */}
                          <div className="tab-content" style={{ marginTop: '20px' }}>
                            {productTabs.length > 0 ? (
                              productTabs.map(tab => (
                                <div key={tab.key} style={{ display: activeTab === tab.key ? 'block' : 'none' }}>
                                  <div className='grid-info-adding' style={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    overflowX: "auto",
                                    boxSizing: "border-box",

                                  }}>

                                    {/* ─── ROW 3: Images  ────────────── */}
                                    <div className="row gappingcls-added">
                                      <div className="col-12">
                                        <div className="info-inner">
                                          <label className="form-label d-flex align-items-center gap-2">
                                            Images
                                          </label>

                                          {/* Upload Container Wrapper */}
                                          <div style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>

                                           {/* UPLOAD CONTAINER */}
<div
  className="upload-container"
  onClick={() => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.multiple = true;
    input.onchange = (e) => handleConfigImageChange(e, tab.key);
    input.click();
  }}
  onDragOver={(e) => e.preventDefault()}
  onDragEnter={() => setIsDragging(true)}
  onDragLeave={() => setIsDragging(false)}
  onDrop={(e) => handleConfigDrop(e, tab.key)}
  style={{
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    border: configImageErrors[tab.key] 
      ? "2px dashed #DC3545" // Error color
      : isDragging 
        ? "2px dashed #0D6EFD" // Dragging color  
        : "2px dashed #ccc",   // Default color
    borderRadius: 4,
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "120px",
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: isDragging ? "#CFE2FF" : "#fff",
    transition: "background-color 0.3s ease, border-color 0.3s ease",
  }}
>
  {/* ICON */}
  <CloudUpload size={32} style={{ marginBottom: "0.5rem" }} />
  
  {/* TEXT */}
  <p style={{ margin: 0, color: "#555", fontSize: "0.9rem" }}>
    Drag your image here or{" "}
    <span style={{ color: "#007bff", textDecoration: "underline" }}>
      Browse
    </span>
  </p>
</div>

{/* ERROR MESSAGE - Same style as SPU images */}
{configImageErrors[tab.key] && (
  <div className="invalid-feedback d-block" style={{ marginTop: '8px' }}>
    {configImageErrors[tab.key]}
  </div>
)}
                                          </div>

                                          {/* Uploaded Images Preview */}
                                          {configImages[tab.key]?.length > 0 && (
                                            <div className="uploaded-images mt-3">
                                              <p className="mb-3">
                                                {configImages[tab.key].length} Image
                                                {configImages[tab.key].length > 1 ? "s" : ""} uploaded
                                              </p>

                                              <ReactSortable
                                                list={configImages[tab.key] || []}
                                                setList={(newList) =>
                                                  setConfigImages((prev) => ({
                                                    ...prev,
                                                    [tab.key]: newList.map((img) => ({
                                                      ...img,
                                                      spuId: img.spuId || id,
                                                      skuIdentifier: img.skuIdentifier || tab.key,
                                                    })),
                                                  }))
                                                }
                                                handle=".drag-handle"
                                                tag="div"
                                                className="row g-2"
                                                chosenClass="is-dragging"
                                              >
                                                {(configImages[tab.key] || []).map((img) => (
                                                  <div className="col-md-4 col-sm-6" key={img.id || img.sku_configuration_image_id}>
                                                    <div className="d-flex align-items-center justify-content-between p-2 border rounded" style={{ boxShadow: "0px 1px 4px 0px #0000001A" }}>

                                                      <div className="d-flex align-items-center gap-2">

                                                        <X
                                                          size={18}
                                                          onClick={() => handleConfigRemove(img.id || img.sku_configuration_image_id, tab.key)}
                                                          className="cursor-pointer"
                                                          style={{ flex: "none" }}
                                                        />

                                                        <img
                                                          src={img.preview || img.sku_image_name}
                                                          alt="preview"
                                                          style={{
                                                            width: 40,
                                                            height: 40,
                                                            objectFit: "cover",
                                                            borderRadius: 4,
                                                          }}
                                                        />

                                                        <div>
                                                          <div style={{
                                                            fontSize: "0.85rem",
                                                            fontWeight: 500,
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            maxWidth: "150px",
                                                            color: "#6C757D"
                                                          }}>
                                                            {img.user_image_name ? img.user_image_name : "Server Image"}
                                                          </div>

                                                          <div style={{ fontSize: "0.75rem", color: "#6C757D" }}>
                                                            {img.file ? formatSize(img.file.size) : ""}
                                                          </div>
                                                        </div>

                                                      </div>

                                                      <Menu
                                                        size={16}
                                                        className="drag-handle text-muted"
                                                        style={{ cursor: "grab", flex: "none" }}
                                                      />

                                                    </div>
                                                  </div>
                                                ))}
                                              </ReactSortable>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    {/* ─── Customised Info ────────────── */}
                                    <div className="row gappingcls-added" style={{ marginTop: '20px' }}>
                                      <div className="col-12">
                                        <div className="info-inner">
                                          <label className="form-label d-flex align-items-center gap-2">
                                            Customised Info
                                          </label>
                                          <div className="info-content d-block entities-tab" style={{ padding: '0' }}>
                                            <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                              <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                                <table className="entities-table tab-table w-100">
                                                  <thead>
                                                    <tr>
                                                      <th />
                                                      <th>
                                                        <span
                                                          style={{
                                                            fontFamily: "Montserrat",
                                                            fontSize: "12px",
                                                            fontWeight: 700,
                                                            fontStyle: "normal",
                                                            color: "#212529",
                                                            display: "flex",
                                                            // alignItems: "center",
                                                            lineHeight: "normal",
                                                          }}
                                                        >
                                                          Field Name <span style={{ color: "#DC3545" }}>*</span>
                                                        </span>
                                                      </th>

                                                      <th>
                                                        <span
                                                          style={{
                                                            fontFamily: "Montserrat",
                                                            fontSize: "12px",
                                                            fontWeight: 700,
                                                            color: "#212529",
                                                            display: "flex",
                                                            // alignItems: "center",
                                                            lineHeight: "normal",
                                                            fontStyle: "normal",
                                                          }}
                                                        >
                                                          Field Type <span style={{ color: "#DC3545" }}>*</span>
                                                        </span>
                                                      </th>
                                                      <th>
                                                        <span
                                                          style={{
                                                            fontFamily: "Montserrat",
                                                            fontSize: "12px",
                                                            fontWeight: 700,
                                                            color: "#212529",
                                                            display: "flex",
                                                            // alignItems: "center",
                                                            lineHeight: "normal",
                                                            fontStyle: "normal",
                                                          }}
                                                        >
                                                          Field Value  <span style={{ color: "#DC3545" }}>*</span>
                                                        </span>
                                                      </th>
                                                      <th />
                                                    </tr>
                                                  </thead>
                                                  <ReactSortable list={rowsCf[tab.key] ?? []} setList={(newList) => setRowsCf(prev => ({ ...prev, [tab.key]: newList }))} handle=".drag-handle" tag="tbody">
                                                    {(rowsCf[tab.key] ?? []).map((r, idx) => {
                                                      if (!rowRefs.current[r.id]) rowRefs.current[r.id] = React.createRef();
                                                      const ref = rowRefs.current[r.id];
                                                      return <CustomFiledRowInConfig key={r.id} refNode={ref} rowState={r} index={idx}
                                                        deleteRow={deleteRowCf} updateRowBulk={updateRowBulkCf} tabID={tab.key}
                                                        rowErrors={rowErrors[r.id] || {}}
                                                        rows={rowsCf[tab.key] ?? []}
                                                        handleCustomFieldBlur={handleCustomFieldBlur}
                                                        validateRowField={validateRowFieldOnBlur}   // ✅ ADD THIS
                                                        setRowErrors={setRowErrors}
                                                      />;
                                                    })}
                                                  </ReactSortable>
                                                </table>
                                              </div>
                                              <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                                                <button onClick={() => addRowCf(tab.key)} className="dark-button">Add Fields</button>
                                              </div>
                                            </div>
                                            <div className="info-content" style={{ padding: "20px 0" }}>
                                              <div className="info-inner common-textarea">
                                                <label className="form-label d-flex align-items-center gap-2">
                                                  Notes
                                                </label>
                                                <textarea
                                                  className="form-control w-100 common-textarea-all"
                                                  rows="3"
                                                  value={
                                                    rows3.find(r => r.uniqueKey === tab.key)?.notes || ""
                                                  }
                                                  onChange={(e) =>
                                                    handleConfigNoteChange(tab.key, e.target.value)
                                                  }
                                                  style={{ border: "1px solid #6C757D" }}
                                                />

                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div>No configurations available</div>
                            )}
                          </div>
                        </div>

                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {activeTab2 === 'sku-code' && (
              <div className="tab-content" id="sku-code-content">
                <div className="info-section">
                  <div className="info-section">
                    {/* ─── SKU Code CARD ─────────────────────────────────────────── */}
                    <div className="info-card new-info-overflow-auto main-company-body-inner">
                      <div className="info-content d-block entities-tab">
                        <div className="table-wrapper" style={{ border: "none", paddingBottom: "10px" }}>
                          <table className="entities-table tab-table w-100 forth-page-table">
                            <thead>
                              <tr>
                                <th style={{minWidth:'245px', padding:'10px'}}><span>SKU Spec </span></th>

                                <SortableHeader
                                  label={<span>SKU Name <span style={{ color: "red" }}>*</span></span>}
                                  field="name"
                                  sortField={sortField}
                                  sortOrder={sortOrder}
                                  handleSort={handleSort}
                                  sortable={false}
                                />
                                <SortableHeader
                                  label={<span>SKU Code <span style={{ color: "red" }}>*</span>
                                    <Tooltip title="SKU Code" body="Auto generated by the rule defined in the SKU Code Scheme, it can be used to tag and track a SKU">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                        <g clip-path="url(#clip0_4743_12572)">
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                          <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                          <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_4743_12572">
                                            <rect width="10" height="10" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </Tooltip>
                                  </span>}
                                  field="sku_code"
                                  sortField={sortField}
                                  sortOrder={sortOrder}
                                  handleSort={handleSort}
                                  sortable={false}
                                />

                                <SortableHeader
                                  label={<span>Enable <span style={{ color: "red" }}>*</span></span>}
                                  field="status"
                                  sortField={sortField}
                                  sortOrder={sortOrder}
                                  handleSort={handleSort}
                                  sortable={false}
                                />

                                <SortableHeader
                                  label={<span>Model Number</span>}
                                  field="model_number"
                                  sortField={sortField}
                                  sortOrder={sortOrder}
                                  handleSort={handleSort}
                                  sortable={false}
                                />

                                <SortableHeader
                                  label={<span>SIM Option <span style={{ color: "red" }}>*</span></span>}
                                  field="sim_option"
                                  sortField={sortField}
                                  sortOrder={sortOrder}
                                  handleSort={handleSort}
                                  sortable={false}
                                />

                                <SortableHeader
                                  label={<span>GTIN
                                    <Tooltip title="GTIN" body="Global Trade Item Number of the SKU" >
                                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                        <g clip-path="url(#clip0_4743_12572)">
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                          <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                          <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_4743_12572">
                                            <rect width="10" height="10" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </Tooltip>
                                  </span>}
                                  field="gtin"
                                  sortField={sortField}
                                  sortOrder={sortOrder}
                                  handleSort={handleSort}
                                  sortable={false}
                                />

                                <SortableHeader
                                  label={<span>MSRP
                                    <Tooltip title="MSRP" body="Manufacturer's Suggested Retail Price of the SKU">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                        <g clip-path="url(#clip0_4743_12572)">
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                          <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                          <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_4743_12572">
                                            <rect width="10" height="10" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </Tooltip>
                                  </span>}
                                  field="msrp"
                                  sortField={sortField}
                                  sortOrder={sortOrder}
                                  handleSort={handleSort}
                                  sortable={false}
                                />
                              </tr>
                            </thead>

                            <tbody>
                              {paginatedRows.map((row, idx) => {
                                const realIndex = startIndex + idx;
                                return (
                                  <tr key={row.sku_id} style={{
                                      backgroundColor: idx % 2 === 0 ? "#FFFFFF" : "#F8F9FA",
                                    }}>
                                    <td style={{minWidth:'245px', padding:'10px'}}>
                                      <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        minHeight: '40px',
                                        gap: '10px',
                                        minWidth: '150px',
                                        maxWidth: '350px'

                                      }}>
                                        {rows2
                                          .filter(r => r.fieldName && r.opts?.length > 0)
                                          .map((variation, varIdx) => {

                                            const attribute = skuAttributes.find(
                                              a => String(a.id) === String(variation.fieldName)
                                            );

                                            const optionId = row?.values?.[variation.fieldName];

                                            const option = skuAttributeOptions.find(
                                              o => String(o.option_id) === String(optionId)
                                            );


                                            return (
                                              <div key={varIdx}>
                                                <span style={{
                                                  color: '#212529',
                                                  fontSize: '12px',
                                                  lineHeight: '15px',
                                                  fontWeight: '400',
                                                  marginBottom: '5px',
                                                  display: 'block',
                                                }}>
                                                  {attribute?.name || variation.fieldNameLabel}
                                                </span>
                                                <span style={{
                                                  backgroundColor: '#FFEB00',
                                                  color: '#212529',
                                                  borderRadius: '16px',
                                                  padding: '4px 8px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  fontSize: '12px',
                                                  fontWeight: '600',
                                                  lineHeight: '17px',
                                                }}>
                                                  {option?.option_value}
                                                </span>
                                              </div>
                                            );
                                          })}
                                      </div>
                                    </td>
{/* For SKU Name input - COMPLETELY REMOVE onBlur */}
<td>
  <input
    type="text"
    style={{ minWidth: '200px', maxWidth: '200px' }}
    className={`form-control common-input-all ${row.nameError ? "err-color" : ""}`}
    value={row?.name || ""}
    onChange={(e) => {
      const value = e.target.value;
      setIsDirty(true);
      
      // Check validation in real-time
      const trimmedValue = value.trim();
      let nameError = "";
      
      if (!trimmedValue) {
        nameError = "SKU Name is required";
      } else {
        const duplicateIndex = skuCodeRows.findIndex((r, i) => 
          i !== realIndex && r?.name?.trim().toLowerCase() === trimmedValue.toLowerCase()
        );
        if (duplicateIndex !== -1) {
          nameError = "SKU Name already exists";
        }
      }
      
      setSkuCodeRows(prev => {
        const updated = [...prev];
        updated[realIndex] = {
          ...updated[realIndex],
          name: value,
          nameError: nameError // Set error based on current value
        };
        return updated;
      });
    }}
    // NO onBlur handler AT ALL - this is the key!
  />

  {row.nameError && (
    <div className="invalid-feedback d-block">
      {row.nameError}
    </div>
  )}
</td>

{/* For SKU Code input - COMPLETELY REMOVE onBlur */}
<td>
  <input
    type="text"
    style={{ minWidth: '200px', maxWidth: '200px' }}
    className={`form-control common-input-all ${row.skuCodeError ? "err-color" : ""}`}
    value={row?.sku_code || ""}
    onChange={(e) => {
      const value = e.target.value;
      setIsDirty(true);
      
      // Check validation in real-time
      const trimmedValue = value.trim();
      let skuCodeError = "";
      
      if (!trimmedValue) {
        skuCodeError = "SKU Code is required";
      } else {
        const duplicateIndex = skuCodeRows.findIndex((r, i) => 
          i !== realIndex && r?.sku_code?.trim().toLowerCase() === trimmedValue.toLowerCase()
        );
        if (duplicateIndex !== -1) {
          skuCodeError = "SKU Code already exists";
        }
      }
      
      setSkuCodeRows(prev => {
        const updated = [...prev];
        updated[realIndex] = {
          ...updated[realIndex],
          sku_code: value,
          skuCodeError: skuCodeError // Set error based on current value
        };
        return updated;
      });
    }}
    // NO onBlur handler AT ALL - this is the key!
  />

  {row.skuCodeError && (
    <div className="invalid-feedback d-block">
      {row.skuCodeError}
    </div>
  )}
</td>
                                    <td style={{ overflow: 'visible' }}>
                                      <div
                                        style={{ position: 'relative', width: 200 }}
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <div
                                          onClick={(e) => {
                                            e.stopPropagation();

                                            const rect = e.currentTarget.getBoundingClientRect();

                                            setSkuCodeRows(prev => {
                                              const updated = [...prev];
                                              updated[realIndex] = {
                                                ...updated[realIndex],
                                                _open: !updated[realIndex]?._open,
                                                _dropdownPos: {
                                                  left: rect.left,
                                                  top: rect.bottom + 6,
                                                  width: rect.width,
                                                },
                                              };
                                              return updated;
                                            });
                                          }}
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            border: '1px solid #6C757D',
                                            borderRadius: 8,
                                            padding: '10px',
                                            height: 40,
                                            cursor: 'pointer',
                                            background: '#fff',
                                            justifyContent: 'space-between',
                                          }}
                                        >
                                          <span
                                            style={{
                                              padding: "5px 10px",
                                              fontWeight: 600,
                                              fontSize: 12,
                                              gap: 10,
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              borderRadius: 99,
                                              minWidth: '72px',
                                              textAlign: 'center',
                                              border: row?.status === '1' ? '1px solid #198754' : '1px solid #DC3545',
                                              backgroundColor:
                                                row?.status === '1' ? '#D1E7DD' : '#F8D7DA',
                                              color:
                                                row?.status === '1' ? '#198754' : '#DC3545',
                                            }}
                                          >
                                            {row?.status === '1' ? 'YES' : 'NO'}
                                          </span>

                                          <ChevronDown size={16} />
                                        </div>

                                        {row?._open &&
                                          ReactDOM.createPortal(
                                            <div
                                              onMouseDown={(e) => e.stopPropagation()}
                                              style={{
                                                position: 'fixed',
                                                top: row._dropdownPos.top,
                                                left: row._dropdownPos.left,
                                                width: row._dropdownPos.width,
                                                background: '#fff',
                                                border: '1px solid #cfd4dc',
                                                borderRadius: 12,
                                                padding: 6,
                                                zIndex: 99999,
                                                boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                                              }}
                                            >
                                              <div
                                                onMouseDown={(e) => {
                                                  e.stopPropagation();
                                                  setSkuCodeRows(prev => {
                                                    const updated = [...prev];
                                                    updated[realIndex] = {
                                                      ...updated[realIndex],
                                                      status: '1',
                                                      _open: false,
                                                    };
                                                    return updated;
                                                  });
                                                }}
                                                style={{
                                                  padding: 8,
                                                  borderRadius: 10,
                                                  cursor: 'pointer',
                                                  background:
                                                    row?.status === '1' ? '#f5f7fa' : 'transparent',
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    padding: '5px 20px',
                                                    borderRadius: 99,
                                                    fontWeight: 600,
                                                    fontSize: 12,
                                                    gap: 10,
                                                    minWidth: '72px',
                                                    textAlign: 'center',
                                                    backgroundColor: '#D1E7DD',
                                                    color: '#198754',
                                                    border: '1px solid #198754',
                                                  }}
                                                >
                                                  YES
                                                </span>
                                              </div>

                                              <div
                                                onMouseDown={(e) => {
                                                  e.stopPropagation();
                                                  setSkuCodeRows(prev => {
                                                    const updated = [...prev];
                                                    updated[realIndex] = {
                                                      ...updated[realIndex],
                                                      status: '0',
                                                      _open: false,
                                                    };
                                                    return updated;
                                                  });
                                                }}
                                                style={{
                                                  padding: 8,
                                                  borderRadius: 10,
                                                  cursor: 'pointer',
                                                  background:
                                                    row?.status === '0' ? '#f5f7fa' : 'transparent',
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    padding: '5px 20px',
                                                    borderRadius: 99,
                                                    fontWeight: 600,
                                                    fontSize: 12,
                                                    gap: 10,
                                                    minWidth: '72px',
                                                    textAlign: 'center',
                                                    backgroundColor: '#F8D7DA',
                                                    color: '#c62828',
                                                    border: '1px solid #dc3545',
                                                  }}
                                                >
                                                  NO
                                                </span>
                                              </div>
                                            </div>,
                                            document.body
                                          )}
                                      </div>
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        style={{ minWidth: '150px', maxWidth: '150px' }}
                                        className="form-control common-input-all"
                                        value={row?.model_number || ''}
                                        onChange={(e) => {
                                          const newValue = e.target.value;
                                          setIsDirty(true);
                                          setSkuCodeRows(prevRows => {
                                            const updatedRows = [...prevRows];
                                            updatedRows[realIndex] = {
                                              ...updatedRows[realIndex],
                                              model_number: newValue,
                                            };
                                            return updatedRows;
                                          });
                                        }}
                                      />
                                    </td>

                                    {/* SIM OPTION */}
                                    <td>
                                      <SimOptionDropdown
                                        value={row?.sim_option || ''}
                                        isDevice={formData.product_type?.toLowerCase() === 'device'}
                                        error={row?.simOptionError || ''}
                                        onChange={(newValue) => {
                                          setIsDirty(true);
                                          setSkuCodeRows(prevRows => {
                                            const updatedRows = [...prevRows];
                                            updatedRows[realIndex] = {
                                              ...updatedRows[realIndex],
                                              sim_option: newValue,
                                              simOptionError: newValue ? '' : updatedRows[realIndex].simOptionError,
                                            };
                                            return updatedRows;
                                          });
                                        }}
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        style={{ minWidth: '200px', maxWidth: '200px' }}
                                        className="form-control common-input-all"
                                        value={row?.gtin || ''}
                                        onChange={(e) => {
                                          const newValue = e.target.value;
                                          setIsDirty(true);
                                          setSkuCodeRows(prevRows => {
                                            const updatedRows = [...prevRows];
                                            updatedRows[realIndex] = {
                                              ...updatedRows[realIndex],
                                              gtin: newValue,
                                            };
                                            return updatedRows;
                                          });
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          width: '150px',
                                          height: '40px',
                                          border: '1px solid #6C757D',
                                          borderRadius: '8px',
                                          backgroundColor: '#fff',
                                          overflow: 'hidden',
                                        }}
                                      >
                                        <span
                                          style={{
                                            padding: '0 12px',
                                            fontSize: '14px',
                                            color: '#6b7280',
                                            borderRight: '1px solid #6C757D',
                                            height: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          SGD
                                        </span>

                                        <input
                                          type="text"
                                          value={row?.msrp || ''}
                                          onChange={(e) => {
                                            const newValue = e.target.value;
                                            setSkuCodeRows(prevRows => {
                                              const updatedRows = [...prevRows];
                                              updatedRows[realIndex] = {
                                                ...updatedRows[realIndex],
                                                msrp: newValue,
                                              };
                                              return updatedRows;
                                            });
                                          }}
                                          style={{
                                            flex: 1,
                                            border: 'none',
                                            outline: 'none',
                                            padding: '0 12px',
                                            fontSize: '14px',
                                            height: '100%',
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </div>
                        {/* {filtered.length > PAGE_SIZE && ( */}
                        <div className="pagination">
                          <div className="pagination-info">
                            {`${startIndex + 1} - ${endIndex} of ${totalItems}`}
                          </div>
                          <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <UnsavedChangesPrompt
          entityName="SPU & SKU"
          isDirty={!isSaving && !discardModalOpen && !isDiscardingRef.current && isDirty}
        />
        <DiscardConfirmationModal
              isOpen={discardModalOpen}
              onCancel={handleCancelDiscard}
              onConfirm={handleDiscardConfirm}
              entityName="SPU and SKU"
            />

      <style>
                    {`
                        .forth-page-table th,
                        .forth-page-table td {
                        position: relative;
                        overflow: visible;
                        }

                        /* Shadow only on first column */
                        .forth-page-table th:nth-child(1)::after,
                        .forth-page-table td:nth-child(1)::after {
                        content: "";
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 6px;       /* width of shadow */
                        height: 100%;
                        background: linear-gradient(
                            to right,
                            rgba(0, 0, 0, 0.12),
                            rgba(0, 0, 0, 0)
                        );
                        pointer-events: none;
                        z-index: 5;
                        }
                    `}
                </style>
      </div > {/* end of company-body */}
    </>
  );
}

function EntityRow({ refNode, rowState: r, index: idx, deleteRow, updateRowBulk, tabID, rowErrors = {},
  validateRowField, rows }) {
  const typeRef = useRef(null);
  const valueRef = useRef(null);
  const [portalStyle, setPortalStyle] = useState({});
  const [typePortalStyle, setTypePortalStyle] = useState({});


  // Position Field Value portal
  useEffect(() => {
    if (r.isOpen && valueRef.current) {
      const rect = valueRef.current.getBoundingClientRect();
      setPortalStyle({
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        background: '#fff',
        border: '1px solid #6c757d',
        borderRadius: '8px',
        overflow: 'visible',
        zIndex: 2000,
      });
    }
  }, [r.isOpen, r.opts, r.search]);


  // Position Field Type portal
  useEffect(() => {
    if (r.typeOpen && typeRef.current) {
      const rect = typeRef.current.getBoundingClientRect();
      setTypePortalStyle({
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        background: '#fff',
        border: '1px solid #6c757d',
        borderRadius: '8px',
        zIndex: 2000,
      });
    }
  }, [r.typeOpen]);

  return (
    <tr ref={refNode} style={{ position: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 'relative' : 'static', zIndex: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 1000 : 'auto' }}>
      <td><button className="btn p-0" onClick={() => deleteRow(r.id)} style={{ boxShadow: 'none' }}><Trash2 size={18} /></button></td>
      <td style={{ minWidth: '200px', maxWidth: '200px' }}><input className={`form-control common-input-all ${rowErrors.fieldName ? "err-color" : ""
        }`} value={r.fieldName} onChange={e => {
          const value = e.target.value;

          // 1️⃣ build updated rows FIRST
          const updatedRows = rows.map(row =>
            row.id === r.id ? { ...row, fieldName: value } : row
          );

          // 2️⃣ update state
          updateRowBulk(r.id, { fieldName: value }, tabID);

          // 3️⃣ validate with updated rows
          validateRowField(
            r.id,
            "fieldName",
            value,
            "Field Name",
            tabID,
            updatedRows
          );
        }}
        onBlur={e => {
          const value = e.target.value;

          const updatedRows = rows.map(row =>
            row.id === r.id ? { ...row, fieldName: value } : row
          );

          validateRowField(
            r.id,
            "fieldName",
            value,
            "Field Name",
            tabID,
            updatedRows
          );
        }}
      />
        {rowErrors.fieldName && (
          <div className="invalid-feedback d-block">
            {rowErrors.fieldName}
          </div>
        )}
      </td>
      {/* FIELD TYPE unchanged */}
      <td style={{ position: 'relative', minWidth: '200px', maxWidth: '200px' }}>
        <div
          ref={typeRef}
          className="form-select new-form-select-cls"
          onClick={() => updateRowBulk(r.id, { typeOpen: !r.typeOpen })}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0.5rem',
            minHeight: '40px',
            background: 'none',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            {r.fieldType === 'Text' ? (
              'Text'
            ) : (
              <>
                Reference
                <span className="pill">{r.refChild}</span>
              </>
            )}
          </span>
          <ChevronDown size={16} style={{ transform: r.typeOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
        </div>

        {r.typeOpen && (
          <OptionPortal style={typePortalStyle}>
            <ul
              className="custom-check"
              style={{
                margin: 0,
                padding: 0,
                listStyle: 'none',
                overflow: 'visible',
                position: 'relative',
              }}
            >
              {/* TEXT OPTION */}
              <li
                style={{
                  padding: '0.5rem 1rem',
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                  fontSize: '14px',
                }}
                onClick={() =>
                  updateRowBulk(r.id, {
                    fieldType: 'Text',
                    refChild: '',
                    value: '',
                    opts: [],
                    typeOpen: false,
                  })
                }
              >
                Text
              </li>
            </ul>
          </OptionPortal>
        )}
      </td>
      {/* FIELD VALUE with portal */}
      <td style={{ position: 'relative', minWidth: '200px', maxWidth: '200px' }}>
        {r.fieldType === 'Text' ? (
          <input
            className={`form-control common-input-all ${rowErrors.value ? "err-color" : ""}`}
            value={r.value}
            onChange={(e) => updateRowBulk(r.id, { value: e.target.value }, tabID)}
            onBlur={(e) => validateRowField(r.id, "value", e.target.value, "Field Value")}

          />
        ) : (
          <>
            <div
              ref={valueRef}
              className="select-box form-control common-input-all"
              onClick={() => updateRowBulk(r.id, { isOpen: !r.isOpen })}
              style={{
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                cursor: 'pointer',
                minHeight: '40px',
              }}
            >
              {Array.isArray(r?.opts) && r.opts.length > 0 ? (
                <>
                  <span
                    className="tag"
                    style={{
                      fontSize: '14px',
                      fontWeight: '400',
                      backgroundColor: 'transparent',
                      color: '#6C757D',
                      maxWidth: '100%',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {r.opts?.[0]?.label}
                  </span>
                  {r.opts.length > 1 && (
                    <span style={{ width: '24px', height: '24px', borderRadius: '50%', marginLeft: '5px', fontSize: '12px', fontWeight: '600', backgroundColor: '#212529', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      +{r.opts.length - 1}
                    </span>
                  )}
                </>
              ) : (
                <span style={{ color: '#999' }}>Select {r?.refChild}</span>
              )}
              <ChevronDown size={16} style={{ marginLeft: 'auto', transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
            </div>

            {r?.isOpen && (
              <OptionPortal style={portalStyle}>
                {/* SEARCH FIELD */}
                <div style={{ padding: '0.5rem', position: 'relative' }}>
                  <Search
                    size={18}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '18px',
                      transform: 'translateY(-50%)',
                      color: '#6c757d',
                    }}
                  />
                  <input
                    type="text"
                    className="form-control common-input-all search-input select-box"
                    placeholder="Search..."
                    value={r.search}
                    onChange={(e) => updateRowBulk(r?.id, { search: e.target.value }, tabID)}
                    style={{ paddingLeft: '2rem' }}
                  />
                </div>

                {/* SEARCH RESULTS HEADER */}
                <div style={{ padding: '0 15px 16px', fontSize: '12px', fontWeight: '400', color: '#6C757D' }}>
                  Search Results
                </div>

                {/* SEARCH RESULTS */}
                <ul
                  className="options-list custom-check info-inner"
                  style={{ listStyle: 'none', margin: 0, padding: '0 1.25rem 0.75rem' }}
                >
                  {REFERENCE_OPTIONS[r.refChild]
                    .filter(opt => opt.label.toLowerCase().includes(r.search.toLowerCase()))
                    .filter(opt => !r.opts.some(o => o.value === opt.value))
                    .map(opt => (
                      <li key={opt.value} style={{ marginBottom: '8px' }}>
                        <label
                          className="option-item"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            fontSize: '0.9rem',
                            fontWeight: '400',
                            lineHeight: '1.4',
                          }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer' }}
                            checked={false}
                            onChange={() => updateRowBulk(r.id, { opts: [...r.opts, opt] })}
                          />
                          {renderLabel(opt.label)}
                        </label>
                      </li>
                    ))}

                </ul>

                {/* SELECTED RESULTS HEADER */}
                {r.opts.length > 0 && (
                  <div style={{ padding: '0 15px 16px', fontSize: '12px', lineHeight: '15px', fontWeight: '400', color: '#6C757D' }}>
                    Selected
                  </div>
                )}

                {/* SELECTED OPTIONS */}
                {r.opts.length > 0 && (
                  <ul
                    className="selected-list custom-check info-inner"
                    style={{ listStyle: 'none', margin: 0, padding: '0 1.25rem 1rem' }}
                  >
                    {r.opts.map(opt => (
                      <li key={opt.value} style={{ marginBottom: '0.5rem' }}>
                        <label
                          className="option-item"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            fontSize: '0.9rem',
                            fontWeight: '400',
                            lineHeight: '1.4',
                          }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer' }}
                            checked={true}
                            onChange={() =>
                              updateRowBulk(r.id, {
                                opts: r.opts.filter(o => o.value !== opt.value),
                              })
                            }
                          />
                          {renderLabel(opt.label)}
                        </label>
                      </li>
                    ))}

                  </ul>
                )}
              </OptionPortal>
            )}
          </>
        )}
        {rowErrors.value && (
          <div className="invalid-feedback d-block">
            {rowErrors.value}
          </div>
        )}
      </td>

      {/* taking too much space in the right side */}
      {/* <td className="drag-handle" style={{ cursor: 'grab' }}><Menu size={18} /></td> */}
      <td
          className="drag-handle"
          style={{
              cursor: "grab",
              verticalAlign: "middle",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border:"none",
              paddingTop:"20px",
          }}
          >
          <Menu size={18} />
      </td>
    </tr>
  );
}
function VariationRow({
  refNode,
  rowState: r,
  index: idx,
  deleteRow,
  updateRow,
  skuAttributes,
  rows2,
}) {
  const skuRef = useRef(null);
  const valueRef = useRef(null);
  const optionsPortalRef = useRef(null);

  const [deleteVariationModalOpen, setDeleteVariationModalOpen] = useState(false);
  const [deleteVariationRowID, setDeleteVariationRowID] = useState(null);
  const handleDeleteVariation = (rID) => {
    setDeleteVariationRowID(rID)
    setDeleteVariationModalOpen(true);
  };
  const handleDeleteVariationConfirm = () => {
    deleteRow(deleteVariationRowID);
    setDeleteVariationModalOpen(false);
  };
  const handleDeleteVariationDiscard = () => {
    setDeleteVariationModalOpen(false);
  };

  const [deleteVariationOptionModalOpen, setDeleteVariationOptionModalOpen] = useState(false);
  const [deleteVariationOptionRowID, setDeleteVariationOptionRowID] = useState(null);
  const handleDeleteVariationOption = (rID) => {
    setDeleteVariationOptionRowID(rID)
    setDeleteVariationOptionModalOpen(true);
  };
  const handleDeleteVariationOptionConfirm = () => {
    const newOpts = r.opts.filter(
      (o) => o.value !== deleteVariationOptionRowID
    );

    updateRow(r.id, {
      opts: newOpts,
      variationOptionsError: validateVariationOptions(newOpts), // ✅ ADD
    });

    setDeleteVariationOptionModalOpen(false);
  };

  const handleDeleteVariationOptionDiscard = () => {
    setDeleteVariationOptionModalOpen(false);
  };

  //--------------------------------------------------------------------
  // AVAILABLE VARIATIONS (no duplicates)
  //--------------------------------------------------------------------
  const getAvailableAttributes = () =>
    skuAttributes.map(attr => ({
      value: String(attr.id),
      label: attr.name,
    }));

  const getFilteredSkuAttributes = () => {
    const all = getAvailableAttributes();
    return skuSearch.trim()
      ? all.filter(attr => attr.label.toLowerCase().includes(skuSearch.toLowerCase()))
      : all;
  };

  const isDuplicateVariation = (value) =>
    rows2.some(
      row => row.id !== r.id && row.fieldName === value
    );


  //--------------------------------------------------------------------
  // AVAILABLE OPTIONS based on Variation
  //--------------------------------------------------------------------
  const getAttributeOptions = () => {
    if (!r.fieldName) return [];

    const attribute = skuAttributes.find(
      attr => String(attr.id) === String(r.fieldName)
    );
    if (!attribute) return [];

    return attribute.options.map(opt => ({
      value: String(opt.value),          // 🔑 force string
      label: opt.label,
      isSelected: r.opts.some(
        o => String(o.value) === String(opt.value) // 🔥 FIX
      ),
    }));
  };
  useEffect(() => {
  if (deleteVariationOptionModalOpen && r.isOpen) {
    updateRow(r.id, { isOpen: false });
  }
}, [deleteVariationOptionModalOpen]);

  //--------------------------------------------------------------------
  // PORTAL STYLING FOR OPTIONS DROPDOWN
  //--------------------------------------------------------------------
  const [portalStyle, setPortalStyle] = useState({});
  const [skuSearch, setSkuSearch] = useState('');
  const skuInputRef = useRef(null);
  const [optionSearch, setOptionSearch] = useState('');
  const optionSearchRef = useRef(null);

  useEffect(() => {
    if (r.openSkuDropdown) {
      if (skuInputRef.current) skuInputRef.current.focus();
    } else {
      setSkuSearch('');
    }
  }, [r.openSkuDropdown]);

  useEffect(() => {
    if (r.isOpen) {
      if (optionSearchRef.current) optionSearchRef.current.focus();
    } else {
      setOptionSearch('');
    }
  }, [r.isOpen]);

  const handleOpenOptions = () => {
    const rect = valueRef.current.getBoundingClientRect();
    setPortalStyle({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
      position: "absolute",
      background: "#FFF",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      zIndex: 2000,
    });
    updateRow(r.id, { isOpen: true });
  };

  //--------------------------------------------------------------------
  // CHIP (OPTION) DRAG SORTING
  //--------------------------------------------------------------------
  const handleDragStart = (index) => {
    updateRow(r.id, { dragIndex: index });
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (r.dragIndex === index) return;

    const updated = [...r.opts];
    const draggedItem = updated[r.dragIndex];

    updated.splice(r.dragIndex, 1);
    updated.splice(index, 0, draggedItem);

    updateRow(r.id, { opts: updated, dragIndex: index });
  };

  const handleDrop = () => {
    updateRow(r.id, { dragIndex: null });
  };
  const attribute = skuAttributes.find(a => String(a.id) === r.fieldName);
  const fieldNameLabel = attribute ? attribute.name : "";
  const validateVariation = (value) => {
    if (!value) return "SKU Variation is required";
    if (isDuplicateVariation(value)) return "SKU Variation already exists";
    return "";
  };
  const validateVariationOptions = (opts) => {
    if (!Array.isArray(opts) || opts.length === 0) {
      return "Variation Options are required";
    }
    return "";
  };

  const handleCloseOptions = () => {
    updateRow(r.id, {
      isOpen: false,
      variationOptionsError: validateVariationOptions(r.opts),
    });
  };
  useEffect(() => {
    if (!r.isOpen) return;

    const handleClickOutside = (e) => {
      const clickedInsideValue =
        valueRef.current && valueRef.current.contains(e.target);

      const clickedInsideOptions =
        optionsPortalRef.current &&
        optionsPortalRef.current.contains(e.target);

      if (!clickedInsideValue && !clickedInsideOptions) {
        handleCloseOptions(); // close + validate
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [r.isOpen, r.opts]);


  //--------------------------------------------------------------------
  // MAIN UI
  //--------------------------------------------------------------------
  return (
    <>
      <DiscardConfirmationModal
        isOpen={deleteVariationModalOpen}
        onCancel={handleDeleteVariationDiscard}
        onConfirm={handleDeleteVariationConfirm}
        entityName="SKU Variation and its Options"
      />
      <DiscardConfirmationModal
        isOpen={deleteVariationOptionModalOpen}
        onCancel={handleDeleteVariationOptionDiscard}
        onConfirm={handleDeleteVariationOptionConfirm}
        entityName="Variation Option"
      />

      <tr ref={refNode} style={{ position: "relative", zIndex: 5,backgroundColor: idx % 2 === 0 ? "#FFFFFF" : "#F8F9FA" }}>
        {/* DELETE ICON */}
        <td>
          <Trash2
            size={16}
            style={{
              cursor: idx === 0 ? "not-allowed" : "pointer",
              opacity: idx === 0 ? 0.3 : 1,
            }}
            // onClick={() => idx !== 0 && deleteRow(r.id)}
            onClick={() => {
              if (idx === 0) return; // 🔒 first row = ineffective
              handleDeleteVariation(r.id);
            }}
          />
        </td>

        {/* SKU VARIATION DROPDOWN */}
        <td style={{ padding: "10px", maxWidth: "210px", position: "relative",verticalAlign:  r.variationOptionsError?"top":"middle",minWidth: "210px" }}>
          <div
            ref={skuRef}
            tabIndex={0}
            onBlur={(e) => {
              if (!skuRef.current?.contains(e.relatedTarget)) {
                const error = validateVariation(r.fieldName);
                updateRow(r.id, {
                  variationError: error,
                  openSkuDropdown: false,
                });
              }
            }}
            onClick={() => {
              if (!r.openSkuDropdown) {
                const rect = skuRef.current.getBoundingClientRect();
                updateRow(r.id, {
                  openSkuDropdown: true,
                  skuPos: {
                    top: rect.bottom + window.scrollY,
                    left: rect.left + window.scrollX,
                    width: rect.width,
                  },
                });
              }
            }}
            style={{
              width: "100%",
              height: r.opts && r.opts.length > 0 ? '49.2px' : '40px',
              border: r.variationError ? "1px solid #dc3545" : "1px solid #6C757D",
              borderRadius: "8px",
              padding: "8px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "text",
              background: "#FFF",
            }}
          >
            <input
              ref={skuInputRef}
              type="text"
              value={r.fieldName && !r.openSkuDropdown ? fieldNameLabel : skuSearch}
              readOnly={!!(r.fieldName && !r.openSkuDropdown)}
              onChange={(e) => {
                setSkuSearch(e.target.value);
                if (!r.openSkuDropdown && skuRef.current) {
                  const rect = skuRef.current.getBoundingClientRect();
                  updateRow(r.id, {
                    openSkuDropdown: true,
                    skuPos: {
                      top: rect.bottom + window.scrollY,
                      left: rect.left + window.scrollX,
                      width: rect.width,
                    },
                  });
                }
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (!r.openSkuDropdown && skuRef.current) {
                  const rect = skuRef.current.getBoundingClientRect();
                  updateRow(r.id, {
                    openSkuDropdown: true,
                    skuPos: {
                      top: rect.bottom + window.scrollY,
                      left: rect.left + window.scrollX,
                      width: rect.width,
                    },
                  });
                }
              }}
              placeholder={r.openSkuDropdown && fieldNameLabel ? fieldNameLabel : 'Select Variation'}
              style={{ border: 'none', flex: 1, outline: 'none', background: 'transparent', color: r.fieldName && !r.openSkuDropdown ? '#000' : '#000', fontSize: 'inherit', padding: 0, cursor: r.fieldName && !r.openSkuDropdown ? 'default' : 'text' }}
            />

            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              {r.fieldName && (
                <button
                  type="button"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    updateRow(r.id, { fieldName: '', fieldNameLabel: '', opts: [], openSkuDropdown: false });
                    setSkuSearch('');
                  }}
                  style={{ border: 'none', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px' }}
                  title="Clear"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M9 3L3 9M3 3L9 9" stroke="#212529" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              )}
              <div
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', transition: '0.2s', cursor: 'pointer' }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const rect = skuRef.current.getBoundingClientRect();
                  updateRow(r.id, {
                    openSkuDropdown: !r.openSkuDropdown,
                    skuPos: {
                      top: rect.bottom + window.scrollY,
                      left: rect.left + window.scrollX,
                      width: rect.width,
                    },
                  });
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  style={{ transform: r.openSkuDropdown ? 'rotate(0deg)' : 'rotate(180deg)', transition: '0.2s' }}
                >
                  <path d="M4.5 11.25L9 6.75L13.5 11.25" stroke="#212529" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
          </div>
          {r.variationError && (
            <div className="invalid-feedback d-block">
              {r.variationError}
            </div>
          )}

          {/* SKU VARIATION DROPDOWN PORTAL - FIXED HEIGHT WITH SCROLL */}
          {r.openSkuDropdown && (
            <OptionPortal
              style={{
                position: "absolute",
                top: r.skuPos?.top,
                left: r.skuPos?.left,
                width: r.skuPos?.width,
                background: "#FFF",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                zIndex: 2000,
              }}
            >
              <div style={{
                maxHeight: "200px",
                overflowY: "auto",
                padding: "0",
              }}>
                {getFilteredSkuAttributes().length === 0 ? (
                  skuSearch.trim() ? (
                    <div style={{ padding: "12px 15px", color: "#adb5bd", fontSize: "13px" }}>No match found</div>
                  ) : null
                ) : getFilteredSkuAttributes().map(attr => (
                  <div
                    key={attr.value}
                    onMouseEnter={() =>
                      updateRow(r.id, { hoverVariation: attr.value })
                    }
                    onMouseLeave={() =>
                      updateRow(r.id, { hoverVariation: null })
                    }
                    onMouseDown={(e) => {
                      e.preventDefault();
                      const error = validateVariation(attr.value);
                      updateRow(r.id, {
                        fieldName: attr.value,
                        opts: [],
                        variationError: error,
                        openSkuDropdown: false,
                      });
                    }}
                    onClick={() =>
                      updateRow(r.id, {
                        fieldName: attr.value,
                        fieldNameLabel: attr.label,
                        opts: [],
                        openSkuDropdown: false,
                      })
                    }
                    style={{
                      padding: "12px 15px",
                      cursor: "pointer",
                      background:
                        r.hoverVariation === attr.value ? "#FFFEF0" : "#FFF",
                    }}
                  >
                    {attr.label}
                  </div>
                ))}
              </div>
            </OptionPortal>
          )}
        </td>

        {/* VARIATION OPTIONS MULTI-SELECT */}
        <td style={{ padding: "10px", flexGrow: 1 , maxWidth: "644px" , verticalAlign:r.variationError ? "top":"middle" }}>
          <div
            ref={valueRef}
            onClick={() => {
              if (!r.isOpen) handleOpenOptions();
              if (optionSearchRef.current) optionSearchRef.current.focus();
            }}
            className="form-control"
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              minHeight: "40px",
              cursor: "text",
              border: r.variationOptionsError
                ? "1px solid #dc3545"   // 🔴 red border on error
                : "1px solid #6C757D", // normal border
              borderRadius: "8px",
            }}
          >
            {r.opts.map((opt, index) => (
                <span
                  key={opt.value}
                  draggable
                  onDragStart={() => handleDragStart(index)}
                  onDragOver={(e) => handleDragOver(e, index)}
                  onDrop={handleDrop}
                  onDragEnd={handleDrop}
                  style={{
                    backgroundColor: "#FFEB00",
                    color: "#212529",
                    borderRadius: "16px",
                    padding: "4px 8px",
                    margin: "2px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "grab",
                    opacity: r.dragIndex === index ? 0.5 : 1,
                    userSelect: "none",
                  }}
                >
                  {/* DRAG ICON FIRST */}
                  <span style={{ display: "flex", alignItems: "center", cursor: "grab" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                      viewBox="0 0 12 12" fill="none">
                      <path d="M2 6H10M2 9H10M2 3H10"
                        stroke="black"
                        strokeWidth="1.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round" />
                    </svg>
                  </span>


                  {/* LABEL */}
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>{opt.label}</span>

                  {/* REMOVE BUTTON */}
                  <button
                    type="button"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteVariationOption(opt.value);
                    }}
                  >
                    <X size={14} strokeWidth={3} />
                  </button>
                </span>
              ))}

            <input
              ref={optionSearchRef}
              type="text"
              value={optionSearch}
              onChange={(e) => {
                setOptionSearch(e.target.value);
                if (!r.isOpen) handleOpenOptions();
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (!r.isOpen) handleOpenOptions();
              }}
              placeholder={r.opts.length === 0 ? "Select options..." : ""}
              style={{ border: 'none', outline: 'none', flex: 1, background: 'transparent', minWidth: '60px', fontSize: 'inherit', padding: 0, alignSelf: 'center' }}
            />

            <ChevronDown
              size={18}
              style={{
                marginLeft: "auto",
                transform: r.isOpen ? "rotate(180deg)" : "rotate(0)",
                color:'#6C757D'
              }}
            />
          </div>
          {r.variationOptionsError && (
            <div className="invalid-feedback d-block">
              {r.variationOptionsError}
            </div>
          )}
          {/* OPTIONS DROPDOWN PORTAL - FIXED HEIGHT WITH SCROLL */}
          {r.isOpen && (
            <OptionPortal style={portalStyle}>
              <div ref={optionsPortalRef}>
                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  <ul
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px",
                      padding: "10px",
                      listStyle: "none",
                    }}
                  >
                    {(() => {
                      const filtered = optionSearch.trim()
                        ? getAttributeOptions().filter(opt => opt.label.toLowerCase().includes(optionSearch.toLowerCase()))
                        : getAttributeOptions();
                      if (filtered.length === 0) {
                        return optionSearch.trim()
                          ? <li style={{ color: "#adb5bd", fontSize: "13px", listStyle: "none" }}>No match found</li>
                          : null;
                      }
                      return filtered.map(opt => {
                        const selected = r.opts.some(o => o.value === opt.value);
                        return (
                          <li key={opt.value}>
                            <div
                              onClick={() => {
                                if (opt.isSelected) return;
                                const newOpts = [...r.opts, opt];
                                updateRow(r.id, {
                                  opts: newOpts,
                                  variationOptionsError: validateVariationOptions(newOpts),
                                });
                                setOptionSearch('');
                              }}
                              style={{
                                padding: "6px 12px",
                                borderRadius: "999px",
                                border: "1px solid #FFEB00",
                                background: selected ? "#FFEB00" : "#FFF",
                                color: "#212529",
                                cursor: "pointer",
                                fontWeight: 600,
                              }}
                            >
                              {opt.label}
                            </div>
                          </li>
                        );
                      });
                    })()}
                  </ul>
                </div>
              </div>
            </OptionPortal>
          )}
        </td>

        {/* DRAG HANDLE */}
        <td className="drag-handle">
          <Menu size={16} style={{ cursor: "grab" }} />
        </td>
      </tr>
    </>
  );
}
function ConfigRow({ 
  refNode, 
  rowState: r, 
  index: idx, 
  deleteRow, 
  updateRow, 
  skuAttributes, 
  rows2, 
  skuAttributeOptions, 
  validateRowField,
  validateConfigConflicts, 
  rowErrors,
  validateConfigurationOptionsCompleteness,
  setRowErrors,
  rows3
}) {
  const valueRef = useRef(null);
  const [portalStyle, setPortalStyle] = useState({});
  const portalRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (r.isOpen && valueRef.current) {
      const rect = valueRef.current.getBoundingClientRect();
      setPortalStyle({
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        background: '#fff',
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        borderRadius: '8px',
        padding: '1rem',
        zIndex: 2000,
        maxHeight: '300px',
        overflowY: 'auto'
      });
    }
  }, [r.isOpen, r.opts]);

  // Handle click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (!r.isOpen) return;
      
      const clickOutsideDropdown = portalRef.current && !portalRef.current.contains(event.target);
      const clickOutsideTrigger = valueRef.current && !valueRef.current.contains(event.target);
      
      if (clickOutsideDropdown && clickOutsideTrigger) {
        validateOptionsOnBlur();
        updateRow(r.id, { isOpen: false });
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [r.isOpen, r.opts, r.id]);

  // Get variation IDs from rows2
  const variationIdsFromRows2 = rows2
    .map(row => row.fieldName)
    .filter(Boolean)
    .map(String);

  const variationIdsFromSelectedOpts = r.opts
    .map(opt => String(opt.preset_id || opt.sku_preset_attribute_id));

  const allVariationIds = Array.from(
    new Set([...variationIdsFromRows2, ...variationIdsFromSelectedOpts])
  );

  const selectedAttributes = skuAttributes.filter(attr =>
    allVariationIds.includes(String(attr.id))
  );

  // Group options by preset name
  const groupedOptions = {};

  selectedAttributes.forEach(attr => {
    const row2Opts =
      rows2.find(row => row.fieldName === String(attr.id))?.opts || [];

    const existingOpts = r.opts.filter(
      opt => String(opt.preset_id || opt.sku_preset_attribute_id) === String(attr.id)
    );

    const allowedOptionIds = Array.from(
      new Set([
        ...row2Opts.map(o => String(o.value)),
        ...existingOpts.map(o => String(o.option_id))
      ])
    );

    const options = (skuAttributeOptions ?? [])
      .filter(
        opt =>
          opt.attribute === attr.id &&
          allowedOptionIds.includes(String(opt.option_id))
      )
      .map(opt => ({
        option_id: opt.option_id,
        option_value: opt.option_value,
        preset_id: attr.id,
        preset_name: attr.name
      }));

    if (options.length) {
      groupedOptions[attr.name] = options;
    }
  });

  // Group selected options for display
  const groupedSelectedOptions = r.opts.reduce((acc, opt) => {
    const presetName = opt.preset_name || 
      skuAttributes.find(a => String(a.id) === String(opt.preset_id || opt.sku_preset_attribute_id))?.name || 
      'Unknown';
    
    if (!acc[presetName]) {
      acc[presetName] = [];
    }
    acc[presetName].push(opt.option_value);
    return acc;
  }, {});

  // Validate configuration name on blur
  const validateConfigNameOnBlur = (rowId, value) => {
    const trimmedValue = value?.trim().toLowerCase();
    let error = "";
    
    if (!trimmedValue) {
      error = "Configuration Name is required";
    } else {
      // Check for duplicate names
      const duplicateName = rows3.some(r =>
        r.id !== rowId &&
        r.fieldName?.trim().toLowerCase() === trimmedValue
      );
      
      if (duplicateName) {
        error = "Configuration Name already exists";
      }
    }
    
    // Update row errors
    setRowErrors(prev => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        configuration_name: error
      }
    }));
    
    updateRow(r.id, { configurationError: error });
    
    return !error; // Return true if valid
  };

  // Validate options on blur
  const validateOptionsOnBlur = () => {
    const requiredError = !r.opts || r.opts.length === 0 ? "Configuration Options are required" : "";
    
    // Check if all variations have at least one option
    const completenessError = validateConfigurationOptionsCompleteness(r, rows2, skuAttributes);
    
    // Get the current error from rowErrors
    const configError = rowErrors?.[r.id]?.configuration_options || "";

    let error = requiredError || completenessError || configError;

    // Update row with error
    updateRow(r.id, {
      skuPresetsError: error,
      configurationError: configError
    });
  };

  // Toggle option selection
  const toggleOption = (optionId, optionValue, presetId) => {
    // Find attribute (preset) by ID
    const preset = skuAttributes.find(
      attr => String(attr.id) === String(presetId)
    );

    const exists = r.opts.some(opt => opt.option_id === optionId);

    const newOpts = exists
      ? r.opts.filter(opt => opt.option_id !== optionId)
      : [
          ...r.opts,
          {
            sku_preset_attribute_id: preset?.id || presetId,
            option_id: optionId,
            option_value: optionValue,
            preset_id: presetId,
            preset_name: preset?.name
          }
        ];

    // Update the row with new options
    updateRow(r.id, {
      opts: newOpts,
    });

    // Validate conflicts with other configurations
    validateConfigConflicts({
      ...r,
      opts: newOpts,
    });

    // Check if all variations now have at least one option
    const completenessError = validateConfigurationOptionsCompleteness(
      { ...r, opts: newOpts }, 
      rows2, 
      skuAttributes
    );

    if (completenessError) {
      setRowErrors(prev => ({
        ...prev,
        [r.id]: {
          ...prev[r.id],
          configuration_options: completenessError
        }
      }));
    } else {
      // Clear the completeness error if resolved
      setRowErrors(prev => ({
        ...prev,
        [r.id]: {
          ...prev[r.id],
          configuration_options: ""
        }
      }));
    }
  };

  return (
    <tr ref={refNode} style={{ position: r.isOpen ? 'relative' : 'static', zIndex: r.isOpen ? 1000 : 'auto', backgroundColor: idx % 2 === 0 ? "#FFFFFF" : "#F8F9FA" }}>
      <td>
        <button className="btn p-0" onClick={() => deleteRow(r.id)} style={{ boxShadow: 'none' }}>
          <Trash2 size={18} />
        </button>
      </td>
      
      {/* Configuration Name Field with error message below */}
      <td style={{ minWidth: '200px', maxWidth: '200px', paddingRight: '0px', verticalAlign: 'top' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <input
            className={`form-control common-input-all ${rowErrors?.[r.id]?.configuration_name ? "err-color" : ""} ${Object.values(rows3).find(rw => rw.id == r.id)?.configurationError ? "err-color" : ""}`}
            value={r.fieldName || ''}
            onChange={e => {
              // Clear error immediately when user starts typing
              if (rowErrors?.[r.id]?.configuration_name) {
                setRowErrors(prev => ({
                  ...prev,
                  [r.id]: {
                    ...prev[r.id],
                    configuration_name: ""
                  }
                }));
              }
              updateRow(r.id, {
                fieldName: e.target.value,
              });
            }}
            onBlur={(e) => {
              // Validate on blur
              validateConfigNameOnBlur(r.id, e.target.value);
              
              // Also validate conflicts
              validateConfigConflicts({
                ...r,
                fieldName: e.target.value,
              });
            }}
          />
          {rowErrors?.[r.id]?.configuration_name && (
            <div className="invalid-feedback d-block" style={{ marginTop: 4, position: 'relative' }}>
              {rowErrors[r.id].configuration_name}
            </div>
          )}
          
          {!rowErrors?.[r.id]?.configuration_name && Object.values(rows3).find(rw => rw.id == r.id)?.configurationError && (
            <div className="invalid-feedback d-block" style={{ marginTop: 4, position: 'relative' }}>
              {Object.values(rows3).find(rw => rw.id == r.id)?.configurationError}
            </div>
          )}
        </div>
      </td>
      
      {/* Configuration Options Field with error message below */}
      <td ref={containerRef} style={{ position: 'relative', minWidth: '400px', maxWidth: '400px', paddingRight: '0px', verticalAlign: 'top' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            ref={valueRef}
            className={`select-box form-control common-input-all ${r.skuPresetsError || rowErrors?.[r.id]?.configuration_options ? "err-color" : ""}`}
            onClick={() => {
              if (r.isOpen) {
                validateOptionsOnBlur();
              }
              updateRow(r.id, { isOpen: !r.isOpen });
            }}
            style={{
              cursor: 'pointer', 
              minHeight: '40px', 
              padding: '0.5rem', 
              display: 'flex',
              alignItems: 'flex-start',
              gap: '6px',
              whiteSpace: 'normal',
              border: rowErrors?.[r.id]?.configuration_options ? 
                '1px solid #dc3545' : '1px solid #6C757D',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
                width: '100%'
              }}
            >
              {/* Display selected options */}
              <span
                style={{
                  display: 'inline-block',
                  fontSize: '13px',
                  fontWeight: 500,
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  lineHeight: '1.4'
                }}
                title={Object.entries(groupedSelectedOptions)
                  .map(([k, v]) => `${k}: ${v.join(', ')}`)
                  .join('; ')
                }
              >
                {Object.entries(groupedSelectedOptions).length > 0 ? (
                  Object.entries(groupedSelectedOptions).map(
                    ([presetName, values], index, arr) => (
                      <span key={presetName}>
                        <strong style={{ display: 'inline' }}>{presetName}</strong>: {values.join(', ')}
                        {index < arr.length - 1 && '; '}
                      </span>
                    )
                  )
                ) : (
                  <span style={{ color: '#999' }}>Select options...</span>
                )}
              </span>
            </div>

            {/* CHEVRON */}
            <ChevronDown
              size={16}
              style={{
                flexShrink: 0,
                transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)',
                marginTop: '4px'
              }}
            />
          </div>
          
          {/* Error message for options */}
          {(r.skuPresetsError || rowErrors?.[r.id]?.configuration_options) && (
            <div className="invalid-feedback d-block" style={{ marginTop: 4, position: 'relative' }}>
              {r.skuPresetsError || rowErrors?.[r.id]?.configuration_options}
            </div>
          )}
        </div>

        {/* Options dropdown portal */}
        {r.isOpen && (
          <OptionPortal style={portalStyle}>
            <div ref={portalRef} onMouseDown={(e) => e.stopPropagation()}>
              {Object.keys(groupedOptions).length > 0 ? (
                Object.entries(groupedOptions).map(([presetName, options]) => (
                  <div key={presetName} style={{ marginBottom: '1rem' }}>
                    <strong style={{ display: 'block', marginBottom: '0.5rem', fontSize: '14px', fontWeight: '600', color: '#6C757D' }}>{presetName}</strong>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {options.map(opt => {
                        const selected = r.opts.some(selectedOpt => selectedOpt.option_id === opt.option_id);
                        return (
                          <span
                            key={opt.option_id}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption(opt.option_id, opt.option_value, opt.preset_id);
                            }}
                            style={{ 
                              padding: '4px 8px', 
                              borderRadius: '16px', 
                              cursor: 'pointer', 
                              fontSize: '12px', 
                              fontWeight: '600', 
                              backgroundColor: selected ? '#FFEB00' : 'transparent', 
                              border: '1px solid #FFEB00', 
                              color: '#212529' 
                            }}
                          >
                            {opt.option_value}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ color: '#999', textAlign: 'center', padding: '1rem' }}>
                  No variation options available. Please set up SKU variations first.
                </div>
              )}
            </div>
          </OptionPortal>
        )}
      </td>
      
      {/* Drag Handle */}
      <td
        className="drag-handle"
        style={{
          cursor: "grab",
          verticalAlign: "middle",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          paddingTop: "20px",
        }}
      >
        <Menu size={18} />
      </td>
    </tr>
  );
}
function CustomFiledRowInConfig({ refNode, rowState: r, index: idx, deleteRow, updateRowBulk, tabID, rowErrors = {},
  validateRowField, rows, setRowErrors }) {
  const typeRef = useRef(null);
  const valueRef = useRef(null);
  const [portalStyle, setPortalStyle] = useState({});
  const [typePortalStyle, setTypePortalStyle] = useState({});

  // Position Field Value portal
  useEffect(() => {
    if (r.isOpen && valueRef.current) {
      const rect = valueRef.current.getBoundingClientRect();
      setPortalStyle({
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        background: '#fff',
        border: '1px solid #6c757d',
        borderRadius: '8px',
        overflow: 'visible',
        zIndex: 2000,
      });
    }
  }, [r.isOpen, r.opts, r.search]);


  // Position Field Type portal
  useEffect(() => {
    if (r.typeOpen && typeRef.current) {
      const rect = typeRef.current.getBoundingClientRect();
      setTypePortalStyle({
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        background: '#fff',
        border: '1px solid #6c757d',
        borderRadius: '8px',
        zIndex: 2000,
      });
    }
  }, [r.typeOpen]);

  return (
    <tr ref={refNode} style={{ position: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 'relative' : 'static', zIndex: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 1000 : 'auto' }}>
      <td><button className="btn p-0" onClick={() => deleteRow(r.id, tabID)} style={{ boxShadow: 'none' }}><Trash2 size={18} /></button></td>
      <td style={{ minWidth: '200px', maxWidth: '200px' }}><input className={`form-control common-input-all ${rowErrors.fieldName ? "err-color" : ""
        }`} value={r.fieldName} onChange={e => updateRowBulk(r.id, { fieldName: e.target.value }, tabID)}
        onBlur={(e) =>
          validateRowField(
            r.id,
            "fieldName",
            e.target.value,
            "Field Name",
            rows,
            setRowErrors
          )
        }
      />
        {rowErrors.fieldName && (
          <div className="invalid-feedback d-block">
            {rowErrors.fieldName}
          </div>
        )}
      </td>
      {/* FIELD TYPE unchanged */}
      <td style={{ position: 'relative', minWidth: '200px', maxWidth: '200px' }}>
        <div
          ref={typeRef}
          className="form-select new-form-select-cls"
          onClick={() => updateRowBulk(r.id, { typeOpen: !r.typeOpen })}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0.5rem',
            minHeight: '40px',
            background: 'none',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            {r.fieldType === 'Text' ? (
              'Text'
            ) : (
              <>
                Reference
                <span className="pill">{r.refChild}</span>
              </>
            )}
          </span>
          <ChevronDown size={16} style={{ transform: r.typeOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
        </div>

        {r.typeOpen && (
          <OptionPortal style={typePortalStyle}>
            <ul
              className="custom-check"
              style={{
                margin: 0,
                padding: 0,
                listStyle: 'none',
                overflow: 'visible',
                position: 'relative',
              }}
            >
              {/* TEXT OPTION */}
              <li
                style={{
                  padding: '0.5rem 1rem',
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                  fontSize: '14px',
                }}
                onClick={() =>
                  updateRowBulk(r.id, {
                    fieldType: 'Text',
                    refChild: '',
                    value: '',
                    opts: [],
                    typeOpen: false,
                  })
                }
              >
                Text
              </li>
            </ul>
          </OptionPortal>
        )}
      </td>
      {/* FIELD VALUE with portal */}
      <td style={{ position: 'relative', minWidth: '200px', maxWidth: '200px' }}>
        {r.fieldType === 'Text' ? (
          <input
            className={`form-control common-input-all ${rowErrors.value ? "err-color" : ""}`}
            value={r.value}
            onChange={(e) => updateRowBulk(r.id, { value: e.target.value }, tabID)}
            onBlur={(e) => validateRowField(r.id, "value", e.target.value, "Field Value", rows, setRowErrors)}

          />
        ) : (
          <>
            <div
              ref={valueRef}
              className="select-box form-control common-input-all"
              onClick={() => updateRowBulk(r.id, { isOpen: !r.isOpen })}
              style={{
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                cursor: 'pointer',
                minHeight: '40px',
              }}
            >
              {Array.isArray(r?.opts) && r.opts.length > 0 ? (
                <>
                  <span
                    className="tag"
                    style={{
                      fontSize: '14px',
                      fontWeight: '400',
                      backgroundColor: 'transparent',
                      color: '#6C757D',
                      maxWidth: '100%',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {r.opts?.[0]?.label}
                  </span>
                  {r.opts.length > 1 && (
                    <span style={{ width: '24px', height: '24px', borderRadius: '50%', marginLeft: '5px', fontSize: '12px', fontWeight: '600', backgroundColor: '#212529', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      +{r.opts.length - 1}
                    </span>
                  )}
                </>
              ) : (
                <span style={{ color: '#999' }}>Select {r?.refChild}</span>
              )}
              <ChevronDown size={16} style={{ marginLeft: 'auto', transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
            </div>

            {r?.isOpen && (
              <OptionPortal style={portalStyle}>
                {/* SEARCH FIELD */}
                <div style={{ padding: '0.5rem', position: 'relative' }}>
                  <Search
                    size={18}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '18px',
                      transform: 'translateY(-50%)',
                      color: '#6c757d',
                    }}
                  />
                  <input
                    type="text"
                    className="form-control common-input-all search-input select-box"
                    placeholder="Search..."
                    value={r.search}
                    onChange={(e) => updateRowBulk(r?.id, { search: e.target.value }, tabID)}
                    style={{ paddingLeft: '2rem' }}
                  />
                </div>

                {/* SEARCH RESULTS HEADER */}
                <div style={{ padding: '0 15px 16px', fontSize: '12px', fontWeight: '400', color: '#6C757D' }}>
                  Search Results
                </div>

                {/* SEARCH RESULTS */}
                <ul
                  className="options-list custom-check info-inner"
                  style={{ listStyle: 'none', margin: 0, padding: '0 1.25rem 0.75rem' }}
                >
                  {REFERENCE_OPTIONS[r.refChild]
                    .filter(opt => opt.label.toLowerCase().includes(r.search.toLowerCase()))
                    .filter(opt => !r.opts.some(o => o.value === opt.value))
                    .map(opt => (
                      <li key={opt.value} style={{ marginBottom: '8px' }}>
                        <label
                          className="option-item"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            fontSize: '0.9rem',
                            fontWeight: '400',
                            lineHeight: '1.4',
                          }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer' }}
                            checked={false}
                            onChange={() => updateRowBulk(r.id, { opts: [...r.opts, opt] })}
                          />
                          {renderLabel(opt.label)}
                        </label>
                      </li>
                    ))}

                </ul>

                {/* SELECTED RESULTS HEADER */}
                {r.opts.length > 0 && (
                  <div style={{ padding: '0 15px 16px', fontSize: '12px', lineHeight: '15px', fontWeight: '400', color: '#6C757D' }}>
                    Selected
                  </div>
                )}

                {/* SELECTED OPTIONS */}
                {r.opts.length > 0 && (
                  <ul
                    className="selected-list custom-check info-inner"
                    style={{ listStyle: 'none', margin: 0, padding: '0 1.25rem 1rem' }}
                  >
                    {r.opts.map(opt => (
                      <li key={opt.value} style={{ marginBottom: '0.5rem' }}>
                        <label
                          className="option-item"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            fontSize: '0.9rem',
                            fontWeight: '400',
                            lineHeight: '1.4',
                          }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer' }}
                            checked={true}
                            onChange={() =>
                              updateRowBulk(r.id, {
                                opts: r.opts.filter(o => o.value !== opt.value),
                              })
                            }
                          />
                          {renderLabel(opt.label)}
                        </label>
                      </li>
                    ))}

                  </ul>
                )}
              </OptionPortal>
            )}
          </>
        )}
        {rowErrors.value && (
          <div className="invalid-feedback d-block">
            {rowErrors.value}
          </div>
        )}
      </td>

      <td className="drag-handle" style={{ cursor: 'grab' }}><Menu size={18} /></td>
    </tr>
  );
}